export default {
  // Common
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Criar',
    search: 'Pesquisar',
    filter: 'Filtrar',
    loading: 'A carregar...',
    noData: 'Sem dados',
    confirm: 'Confirmar',
    close: 'Fechar',
    yes: 'Sim',
    no: 'Não',
    actions: 'Ações',
    status: 'Estado',
    date: 'Data',
    name: 'Nome',
    description: 'Descrição',
    type: 'Tipo',
    download: 'Descarregar',
    upload: 'Carregar',
    copy: 'Copiar',
    copied: 'Copiado!',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    all: 'Todos',
    allTypes: 'Todos os tipos',
    allStatuses: 'Todos os estados',
    none: 'Nenhum',
    active: 'Ativo',
    inactive: 'Inativo',
    enabled: 'Ativado',
    disabled: 'Desativado',
    refresh: 'Atualizar',
    back: 'Voltar',
    next: 'Seguinte',
    previous: 'Anterior',
    finish: 'Terminar',
    submit: 'Submeter',
    confirmDeleteItem: 'Deseja eliminar este item?',
    validateForReport: 'Validar para Relatório',
    reset: 'Reiniciar',
    view: 'Ver',
    details: 'Detalhes',
    more: 'Mais',
    less: 'Menos',
    today: 'Hoje',
    yesterday: 'Ontem',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mês',
    optional: 'Opcional',
    required: 'Obrigatório',
    note: 'Nota:',
    and: 'e',
    useAssistant: 'Use o assistente IA para começar',
    goBack: 'Voltar ao painel',
    unknown: 'Desconhecido',
    notDetected: 'Não detetado',
    notDetectedFeminine: 'Não detetada',
    notAvailable: 'Não disponível',
    requiredFields: 'Campos obrigatórios',
    andThe: 'e os',
    or: 'ou',
    sending: 'A enviar...',
    redirecting: 'A redirecionar...',
    copyright: '© 2026 SYLink. Todos os direitos reservados.',
    add: 'Adicionar',
    execute: 'Executar',
    launch: 'Lançar',
    pause: 'Pausa',
    generating: 'A gerar...',
    copiedToClipboard: 'Copiado para a área de transferência',
    emailRequired: 'Email obrigatório',
    regenerate: 'Regenerar',
    deselect: 'Desselecionar',
  },

  // Navigation
  nav: {
    dashboard: 'Painel',
    scans: 'Análises',
    workspaces: 'Workspaces',
    vulnerabilities: 'Vulnerabilidades',
    reports: 'Relatórios',
    settings: 'Definições',
    account: 'A minha conta',
    logout: 'Sair',
    help: 'Ajuda',
    admin: 'Administração',
    tools: 'Ferramentas',
    compliance: 'Conformidade',
    notifications: 'Notificações',
    credentials: 'Credenciais',
    ad: 'Active Directory',
    sessions: 'Sessões',
    agents: 'Agentes'
  },

  // Auth
  auth: {
    login: 'Iniciar sessão',
    logout: 'Terminar sessão',
    register: 'Registar',
    email: 'Email',
    password: 'Palavra-passe',
    confirmPassword: 'Confirmar palavra-passe',
    forgotPassword: 'Esqueceu a palavra-passe?',
    magicLink: 'Magic Link',
    resetPassword: 'Redefinir palavra-passe',
    resetPasswordNeedsLink: 'Para redefinir a sua palavra-passe, utilize o link enviado por e-mail. Pode solicitar um novo link na página de início de sessão.',
    rememberMe: 'Lembrar-me',
    loginSuccess: 'Sessão iniciada com sucesso',
    loginError: 'Credenciais inválidas',
    logoutSuccess: 'Sessão terminada com sucesso',
    sessionExpired: 'Sessão expirada',
    twoFactor: 'Autenticação de dois fatores',
    enterCode: 'Introduza o código',
    verifyCode: 'Verificar código',
    invalidCode: 'Código inválido',
    // Register page
    createAccount: 'Criar uma conta',
    fillFormBelowEmail: 'Preencha o formulário abaixo para criar sua conta empresarial.',
    companyName: 'Nome da empresa',
    companyPlaceholder: 'Sua empresa',
    firstName: 'Nome',
    firstNamePlaceholder: 'Seu nome',
    lastName: 'Sobrenome',
    lastNamePlaceholder: 'Seu sobrenome',
    professionalEmail: 'Email profissional',
    professionalEmailPlaceholder: 'voce@suaempresa.com.br',
    professionalPhone: 'Telefone profissional',
    phonePlaceholder: '+55 11 98765 4321',
    passwordEmailNote: 'Você definirá sua senha após validar seu email.',
    acceptTermsPrefix: 'Eu aceito os',
    createMyAccount: 'Criar minha conta',
    registering: 'Criando...',
    alreadyHaveAccount: 'Já tem uma conta?',
    loginButton: 'Entrar',
    byRegistering: 'Ao criar uma conta, você aceita nossos termos de uso e política de privacidade.',
    registrationSuccess: 'Registro bem-sucedido!',
    registrationEmailSent: 'Um email de confirmação foi enviado para',
    clickLinkToSetPassword: 'Clique no link para definir sua senha e ativar sua conta.',
    checkSpam: 'Verifique sua pasta de spam se não encontrar o email.',
    backToLogin: 'Voltar ao login',
    // Email verification
    verifying: 'Verificando...',
    verifyingDescription: 'Por favor aguarde enquanto verificamos seu endereço de email.',
    emailVerified: 'Email verificado!',
    accountActive: 'Sua conta está agora ativa.',
    welcome: 'Bem-vindo ao SYLink!',
    choosePlan: 'Escolher meu plano',
    redirectingToPlan: 'Redirecionando para preços em {seconds} segundos...',
    orLoginDirectly: 'Ou {loginLink} diretamente',
    verificationFailed: 'Verificação falhou',
    needNewVerificationLink: 'Precisa de um novo link de verificação?',
    yourEmail: 'Seu email',
    emailSent: 'Email enviado!',
    resendLink: 'Reenviar link',
    invalidLink: 'Link inválido',
    requestNewVerificationLink: 'Solicitar um novo link de verificação',
    sendLink: 'Enviar link',
    // Login page
    welcomeBack: 'Bem-vindo de volta!',
    enterCredentials: 'Digite suas credenciais para acessar seu espaço.',
    loggingIn: 'Entrando...',
    noAccount: 'Não tem uma conta?',
    createAccountLink: 'Criar uma conta',
    createFreeAccount: 'Criar uma conta gratuita',
    // Password reset
    resetPasswordTitle: 'Redefinir senha',
    resetPasswordDesc: 'Digite seu email para receber um link de redefinição.',
    sendResetLink: 'Enviar link',
    sending: 'Enviando...',
    resetLinkSent: 'Link enviado!',
    resetLinkSentDesc: 'Verifique seu email para redefinir sua senha.',
    newPassword: 'Nova senha',
    confirmNewPassword: 'Confirmar senha',
    setNewPassword: 'Definir senha',
    passwordUpdated: 'Senha atualizada!',
    passwordUpdatedDesc: 'Agora você pode fazer login com sua nova senha.',
    // Missing auth keys
    accountBlocked: 'Conta bloqueada',
    autoRedirecting: 'Redirecionamento automático...',
    charactersCount: '{count} caracteres',
    checkYourInbox: 'Verifique a sua caixa de entrada',
    chooseSecurePassword: 'Escolha uma palavra-passe segura para a sua conta',
    classic: 'Clássico',
    confirmPasswordPlaceholder: 'Confirme a sua palavra-passe',
    connectionError: 'Erro de ligação. Verifique a sua conexão à internet e tente novamente.',
    createAccountWithProfessionalEmail: 'Criar conta com email profissional',
    createDemoAccount: 'Criar a sua conta demo',
    createNewAccountMessage: 'Para continuar, crie uma nova conta com o seu email profissional:',
    demoAccountReady: 'A sua conta demo está pronta!',
    emailAddressLabel: 'Endereço de email',
    emailNotVerified: 'Email não verificado',
    emailNotVerifiedMessage: 'Por favor verifique a sua caixa de entrada e clique no link de confirmação.',
    emailOrUsername: 'Endereço de email',
    emailPlaceholder: 'o-seu-email@exemplo.com',
    emailSentTitle: 'Email enviado',
    enterEmailForResetLink: 'Introduza o seu endereço de email e enviaremos um link para redefinir a sua palavra-passe.',
    fillDemoInfo: 'Preencha as suas informações para aceder ao seu espaço demo.',
    forgotPasswordModalTitle: 'Palavra-passe esquecida?',
    genericError: 'Ocorreu um erro. Por favor tente novamente.',
    ifAccountExistsPrefix: 'Se existir uma conta com o endereço',
    ifAccountExistsSuffix: ', receberá um link para redefinir a sua palavra-passe.',
    linkExpiresCheckSpam: 'O link expira em 24 horas. Não se esqueça de verificar o spam.',
    loginSubtitle: 'Inicie sessão para aceder ao seu espaço de segurança.',
    lowercase: '1 minúscula',
    magicLinkExpired: 'Este link expirou. Por favor solicite um novo.',
    magicLinkFooter: 'Magic Link - Início de sessão seguro sem palavra-passe',
    magicLinkInvalid: 'Este link já não é válido.',
    magicLinkLoginFailed: 'O início de sessão falhou. Por favor tente novamente.',
    magicLinkNotFound: 'Este link não existe ou já foi utilizado.',
    minChars: '8 caracteres mín.',
    needHelp: 'Precisa de ajuda? Contacte-nos',
    newPasswordPlaceholder: 'Introduza a sua nova palavra-passe',
    number: '1 número',
    orEnterManually: 'ou introduza manualmente',
    passwordChanged: 'Palavra-passe alterada!',
    passwordGenerator: 'Gerador de palavra-passe',
    passwordMinLength: 'Mínimo 8 caracteres',
    passwordMinLengthError: 'A palavra-passe deve ter pelo menos 8 caracteres',
    passwordPlaceholder: 'Palavra-passe',
    passwordResetSuccess: 'A sua palavra-passe foi redefinida com sucesso. Será redirecionado para a página de início de sessão.',
    passwordsMatch: 'Palavras-passe idênticas',
    personalEmailBlockedMessage: 'Esta conta usa um endereço de email pessoal que já não é aceite.',
    personalEmailsNotAccepted: 'Emails pessoais (Gmail, Hotmail, Yahoo, etc.) não são aceites.',
    phoneFormatHint: 'Formato: +351 912 345 678',
    professionalEmailOnly: 'Apenas endereços de email profissionais são permitidos.',
    quantumResistant: 'Resistente a Quantum',
    quantumSecurityDescription: 'Segurança máxima contra futuros ataques quânticos',
    redirectingToDashboard: 'Será redirecionado para o seu painel...',
    regenerate: 'Regenerar',
    requestNewMagicLink: 'Pode solicitar um novo magic link na página de início de sessão.',
    resendVerificationLink: 'Reenviar email de verificação',
    resettingPassword: 'A redefinir...',
    retrying: 'Nova tentativa...',
    securityPolicy: 'Política de segurança:',
    sendResetLinkFull: 'Enviar link de redefinição',
    sendingInProgress: 'A enviar...',
    specialChar: '1 caractere especial',
    unauthorized: 'Acesso não autorizado',
    uppercase: '1 maiúscula',
    verificationEmailSent: 'Email de verificação enviado!',
    verificationTimeout: 'A verificação demorou demasiado. Por favor tente novamente.',
    verifyingLink: 'Estamos a verificar o seu link de início de sessão',
    createFreeAccount: 'Criar uma conta gratuita'
  },

  // Dashboard
  dashboard: {
    title: 'Painel',
    welcome: 'Bem-vindo, {name}',
    overview: 'Visão geral',
    recentScans: 'Análises recentes',
    statistics: 'Estatísticas',
    quickActions: 'Ações rápidas',
    newScan: 'Nova análise',
    viewAllScans: 'Ver todas as análises',
    totalScans: 'Total de análises',
    activeScans: 'Análises ativas',
    completedScans: 'Análises concluídas',
    failedScans: 'Análises falhadas',
    vulnerabilitiesFound: 'Vulnerabilidades encontradas',
    criticalVulns: 'Vulnerabilidades críticas',
    highVulns: 'Vulnerabilidades altas',
    mediumVulns: 'Vulnerabilidades médias',
    lowVulns: 'Vulnerabilidades baixas',
    systemHealth: 'Estado do sistema',
    toolsStatus: 'Estado das ferramentas',
    cpuUsage: 'Utilização CPU',
    memoryUsage: 'Utilização de memória',
    diskUsage: 'Utilização de disco',
    // Service status
    services: {
      backendApi: 'API Backend',
      frontend: 'Frontend',
      postgresql: 'PostgreSQL',
      aiModels: 'Modelos IA'
    },
    serviceStatus: {
      online: 'Online',
      offline: 'Offline',
      checking: 'A verificar',
      degraded: 'Degradado'
    },
    // Missing dashboard keys
    recentActivity: 'Atividade recente',
    monitoring: 'Monitorização e análise de segurança em tempo real',
    critical: 'crit',
    serverPerformance: 'Desempenho do servidor',
    realtimeMonitoring: 'Monitorização em tempo real dos recursos do sistema',
    online: 'Online',
    uptime: 'Tempo de funcionamento',
    activeProcesses: 'Processos ativos',
    scansToday: 'Análises hoje',
    networkLoad: 'Carga de rede',
    temperature: 'Temperatura',
    started: 'Iniciado',
    noActiveScans: 'Sem análises ativas. Inicie uma nova análise para começar.',
    noRecentActivity: 'Sem atividade recente.',
    startAssessment: 'Iniciar avaliação de segurança',
    exportResults: 'Exportar resultados das análises',
    attackTools: {
      reconnaissance: 'Reconhecimento',
      exploitation: 'Exploração',
      bruteForce: 'Força Bruta',
      postExploitation: 'Pós-Exploração',
      privilegeEscalation: 'Escalada de Privilégios'
    },
    targets: {
      webApps: 'Aplicações Web',
      servers: 'Servidores',
      databases: 'Bases de dados',
      network: 'Rede',
      networkDevices: 'Routers, switches',
      target: 'Alvo'
    },
    resources: {
      high: 'Elevado',
      medium: 'Médio',
      normal: 'Normal',
      critical: 'Crítico',
      optimal: 'Ótimo',
      active: 'Ativo',
      inUse: 'Em uso',
      idle: 'Em espera',
      notDetected: 'Não detetado',
      gpuNotAvailable: 'GPU não disponível',
      aiDisabled: 'IA desativada',
      cores: 'núcleos',
      multiCore: 'Multi-núcleos',
      systemLoad: 'Carga do sistema',
      used: 'usados',
      calculating: 'A calcular...',
      total: 'total',
      totalCores: 'Núcleos totais',
      totalMemory: 'RAM total',
      computePower: 'Poder de cálculo',
      ramCapacity: 'Capacidade de memória',
      aiCapacity: 'Capacidade IA',
      availableTotal: 'Disponível / Total',
      cpuCores: 'Núcleos CPU',
      ramInfra: 'RAM Infra.',
      gpuVram: 'VRAM GPU',
      aiReady: 'IA Pronta',
      temperatureOk: 'OK',
      servers: 'servidores',
      onlineCount: 'online',
      offlineCount: 'offline',
      gpuOnline: 'GPU online',
      model: 'modelo'
    },
    infrastructureTotal: 'Infraestrutura total'
  },

  // Scans
  scans: {
    title: 'Análises',
    newScan: 'Nova análise',
    scanHistory: 'Histórico de análises',
    target: 'Alvo',
    targets: 'Alvos',
    scanType: 'Tipo de análise',
    startScan: 'Iniciar análise',
    stopScan: 'Parar análise',
    pauseScan: 'Pausar',
    resumeScan: 'Retomar',
    deleteScan: 'Eliminar análise',
    scanDetails: 'Detalhes da análise',
    scanResults: 'Resultados da análise',
    progress: 'Progresso',
    duration: 'Duração',
    startedAt: 'Iniciado em',
    completedAt: 'Concluído em',
    status: {
      waiting: 'Na fila',
      pending: 'Pendente',
      running: 'Em execução',
      completed: 'Concluído',
      failed: 'Falhado',
      cancelled: 'Cancelado',
      paused: 'Em pausa'
    },
    types: {
      quick: 'Análise rápida',
      full: 'Análise completa',
      stealth: 'Análise furtiva',
      aggressive: 'Análise agressiva',
      custom: 'Análise personalizada',
      iot_scan: 'Análise IoT',
      ot_scan: 'Análise OT/SCADA',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      network_discovery: 'Descoberta de rede',
      vulnerability_scan: 'Análise de vulnerabilidades',
      expert: 'Análise especializada',
      api_pentest: 'Pentest API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Análise Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Engenharia social',
      red_team: 'Red Team',
      phishing: 'Campanha de phishing'
    },
    phases: {
      discovery: 'Descoberta',
      portScan: 'Análise de portas',
      serviceDetection: 'Deteção de serviços',
      vulnScan: 'Análise de vulnerabilidades',
      exploitation: 'Exploração',
      reporting: 'Geração de relatório'
    },
    stealthMode: {
      title: 'Modo Furtivo',
      description: 'Técnicas de evasão IDS/IPS',
      none: 'Nenhum',
      noneDesc: 'Análise rápida, facilmente detetável',
      basic: 'Básico',
      basicDesc: 'Pacotes fragmentados',
      advanced: 'Avançado',
      advancedDesc: 'Temporização lenta + spoofing',
      paranoid: 'Paranoico',
      paranoidDesc: 'Evasão máxima (muito lento)',
      warning: 'Os modos furtivos utilizam técnicas de evasão para evitar a deteção IDS/IPS'
    },
    hosts: 'Hosts',
    ports: 'Portas',
    services: 'Serviços',
    openPorts: 'Portas abertas',
    closedPorts: 'Portas fechadas',
    filteredPorts: 'Portas filtradas',
    noResults: 'Nenhum resultado encontrado',
    exportResults: 'Exportar resultados',
    scanFailed: 'Análise falhada',
    genericError: 'Ocorreu um erro durante a execução da análise. Isto pode ser devido a problemas de conectividade de rede, alvos inacessíveis ou recursos insuficientes.',
    technicalDetails: 'Detalhes técnicos',
    retryScan: 'Repetir esta análise',
    // Cleanup mode
    cleanup: 'Limpeza',
    cleanupTitle: 'Limpeza pós-pentest',
    cleanupDescription: 'Esta ação irá remover todos os rastros deixados pelo pentest, incluindo:',
    cleanupSessions: 'Sessões de exploração ativas',
    cleanupPersistence: 'Mecanismos de persistência instalados',
    cleanupFiles: 'Ficheiros temporários e evidências',
    cleanupLogs: 'Logs de execução APT',
    cleanupPreview: 'Pré-visualização da limpeza',
    sessionsCount: 'Sessões',
    withPersistence: 'Com persistência',
    aptExecutions: 'Execuções APT',
    evidenceFiles: 'Ficheiros de evidência',
    evidenceSize: 'Tamanho das evidências',
    cleanNow: 'Limpar agora',
    archiveAndClean: 'Arquivar e limpar',
    cleaning: 'A limpar...',
    cleanupSuccess: 'Limpeza concluída com sucesso',
    cleanupPartial: 'Limpeza parcial (alguns erros)',
    cleanupFailed: 'Limpeza falhou',
    sessionsClosed: 'Sessões fechadas',
    persistenceRemoved: 'Persistência removida',
    filesCleaned: 'Ficheiros limpos',
    aptLogsCleaned: 'Logs APT limpos',
    evidenceArchived: 'Evidências arquivadas',
    cleanupWarning: '⚠️ Esta ação é irreversível. Certifique-se de ter guardado os dados importantes.',
    status: {
      queued: 'Na fila',
      stopped: 'Parado',
      scheduled: 'Agendado',
    },
    filters: {
      all: 'Todos',
      failed: 'Falhados',
    },
    types: {
      ai_scan: 'Análise IA',
      cloud_scan: 'Análise Cloud',
    },
    stealthMode: {
      basicTime: 'A análise demorará aproximadamente 2x mais',
      advancedTime: 'A análise demorará aproximadamente 5x mais',
      paranoidTime: 'A análise demorará aproximadamente 10x mais',
    },
    advancedDiscoveryOptions: 'Opções de descoberta avançadas',
    configureScan: 'Configurar os parâmetros detalhados da análise',
    steps: {
      targetType: 'Alvo e Tipo',
      networkMode: 'Modo de Rede',
      scanOptions: 'Opções',
      advanced: 'Avançado',
      review: 'Verificação',
    },
    allScans: 'Total',
    activeScans: 'Análises ativas',
    withSuccess: 'Concluídas com sucesso',
    vulnerabilities: 'Vulnerabilidades',
    discovered: 'Hosts detetados',
    toReview: 'A verificar',
    sortByDate: 'Ordenar por data',
    sortByStatus: 'Ordenar por estado',
    sortByVulns: 'Ordenar por vuln.',
    tooltips: {
      totalScans: 'Total de Análises',
      totalScansDesc: 'Número total de análises iniciadas na plataforma. Inclui todas as análises: em curso, concluídas e falhadas.',
      runningScans: 'Análises em Curso',
      runningScansDesc: 'Análises atualmente em execução. Analisam os alvos para detetar portas abertas, serviços e vulnerabilidades.',
      completedScans: 'Análises Concluídas',
      completedScansDesc: 'Análises que foram concluídas com sucesso. Os resultados estão disponíveis para consulta e exportação nos relatórios.',
      vulnerabilities: 'Vulnerabilidades Detetadas',
      vulnerabilitiesDesc: 'Total de falhas de segurança identificadas. Os emblemas indicam o número de vulnerabilidades críticas e altas que requerem atenção imediata.',
      hostsDiscovered: 'Hosts Descobertos',
      hostsDiscoveredDesc: 'Número de máquinas (servidores, postos, equipamentos de rede) detetadas durante as análises. Cada host pode ter várias portas e serviços expostos.',
      failedScans: 'Análises Falhadas',
      failedScansDesc: 'Análises falhadas (alvo inacessível, timeout, problema de rede). Consulte os detalhes para entender a causa e relançar se necessário.',
    },
    notFound: 'Análise não encontrada',
    notFoundDesc: 'A análise solicitada não existe ou foi eliminada',
    backToScans: 'Voltar às análises',
    consoleLive: 'Consola em direto',
    consoleCompleted: 'Consola (Concluída)',
    consoleFailed: 'Consola (Falhada)',
    consoleTitle: 'Consola',
    scanCompletedMessage: '✓ Concluída!',
    scanFailedMessage: '✗ Análise falhada',
    stepCompleted: 'Concluído',
    stepWaiting: 'Em espera',
    stepInProgress: 'Análise em curso',
    timestampStarted: 'Iniciada',
    timestampCompleted: 'Concluída',
    aiQuotaExceeded: 'Quota de análises IA atingida',
    aiScansUsed: 'Análises IA usadas',
    upgradeOptions: 'Opções para continuar',
    callSylink: 'Ligue para o serviço ao cliente SYLink:',
    upgradePlan: 'Mude para um plano superior para análises IA ilimitadas',
    viewPlans: 'Ver os planos',
    networkDiscovery: 'Descoberta de Rede',
    networkDiscoveryDesc: 'Descoberta rápida de hosts e portas',
    vulnerabilityScan: 'Análise de Vulnerabilidades',
    vulnerabilityScanDesc: 'Análise aprofundada de vulnerabilidades',
    fullAutonomous: 'Autónomo completo',
    fullAutonomousDesc: 'Avaliação de segurança completa',
    placeholders: {
      target: '192.168.1.0/24 ou exemplo.com',
      targetExamples: 'Exemplos: 192.168.1.1, 192.168.1.0/24, exemplo.com, 10.0.0.0/8',
      customPorts: 'Ex: 80,443,8080-8090',
      excludeHosts: 'Ex: 192.168.1.1,192.168.1.5',
    },
    searchPlaceholder: 'Pesquisar por Alvo ou Tipo...',
    table: {
      name: 'Nome',
      score: 'Pontuação',
      target: 'Alvo',
      client: 'Cliente',
      type: 'Tipo',
      status: 'Estado',
      vulnerabilities: 'Vuln.',
      date: 'Data',
      actions: 'Ações',
    },
    noCaptures: 'Sem capturas',
    noLogsAvailable: 'Sem logs disponíveis',
    waitingForLogs: 'À espera dos logs...',
    discoveringHosts: 'Descoberta de hosts em curso...',
    noHostDiscovered: 'Nenhum host descoberto',
    analyzingVulns: 'Análise de vulnerabilidades em curso...',
    noVulnDetected: 'Nenhuma vulnerabilidade detetada',
    noCriticalVulns: 'Nenhuma vulnerabilidade crítica detetada.',
    noAttackScenario: 'Nenhum cenário de ataque crítico identificado.',
    noWeakness: 'Nenhuma fraqueza crítica detetada',
    noContent: 'Sem conteúdo disponível',
    noData: 'Sem dados disponíveis',
    noVpnSession: 'Nenhuma sessão VPN está atualmente ativa para este workspace.',
    loadingExecutiveReport: 'A carregar o relatório executivo...',
    saveSchedule: 'Guardar o agendamento',
    noActiveScan: 'Nenhuma análise em curso',
    noScanFound: 'Nenhuma análise encontrada',
    noScanResult: 'Sem resultados para "{query}"',
    noScanStatus: 'Sem análises com o estado "{status}"',
    noVulnerabilities: 'Sem vulnerabilidades',
    loadingError: 'Erro de carregamento',
    deleteFailedScans: 'Eliminar as falhadas',
    deleteFailedScansTitle: 'Eliminar todas as análises falhadas',
    confirmDeleteFailed: 'Eliminar {count} análise(s) falhada(s)?',
    deleteScansError: 'Erro ao eliminar as análises',
    associateScansError: 'Erro ao associar as análises',
    removeScansError: 'Erro ao remover a análise',
    restartScansError: 'Erro ao relançar as análises',
    restartError: 'Erro ao relançar',
    loadScansError: 'Erro ao carregar as análises',
    networkError: 'Erro de rede. Verifique a sua ligação e tente novamente.',
    validateScansError: 'Erro ao validar as análises',
    imageLoadError: 'Erro ao carregar a imagem',
    noWorkspaceForScan: 'Nenhum workspace associado a esta análise. Por favor selecione um cliente na página Clientes, depois relance a análise.',
    pdfGenerationError: 'Erro de geração PDF',
    scheduleSaved: 'Guardar o agendamento',
    scheduleError: 'Erro ao criar o agendamento',
    generatePdfError: 'Erro ao gerar o PDF',
    errors: {
      createFailed: 'Falha ao criar a varredura',
      serverError: 'Erro do servidor durante a varredura',
      workspaceRequired: 'Workspace necessário para iniciar uma varredura'
    },
    screenshotLoadError: 'Erro ao carregar a captura',
  },

  // Workspaces
  workspaces: {
    title: 'Espaços de clientes',
    newWorkspace: 'Novo espaço',
    editWorkspace: 'Editar espaço',
    deleteWorkspace: 'Eliminar espaço',
    workspaceDetails: 'Detalhes do espaço',
    clientName: 'Nome do cliente',
    clientInfo: 'Informação do cliente',
    members: 'Membros',
    addMember: 'Adicionar membro',
    removeMember: 'Remover membro',
    scansCount: 'Número de análises',
    lastActivity: 'Última atividade',
    created: 'Criado em',
    shareWorkspace: 'Partilhar espaço',
    archiveWorkspace: 'Arquivar espaço',
    noWorkspaces: 'Sem espaços de clientes',
    // Additional workspace keys
    scans: 'Varreduras',
    hosts: 'Hosts',
    vulnerabilities: 'Vulnerabilidades',
    attackPaths: 'Caminhos de ataque',
    successfulScans: 'Varreduras bem-sucedidas',
    company: 'Empresa',
    legalForm: 'Forma jurídica',
    address: 'Endereço',
    city: 'Cidade',
    website: 'Website',
    shareDescription: 'Partilhe este espaço com os seus clientes ou colaboradores',
    manageShares: 'Gerir partilhas',
    mainContact: 'Contacto principal',
    contact: 'Contacto',
    signed: 'Assinado',
    pending: 'Pendente',
    draft: 'Rascunho',
    contractSigned: 'Contrato assinado',
    pendingContract: 'Contrato pendente',
    noContract: 'Sem contrato',
    noScans: 'Sem varreduras associadas',
    noScansHint: 'Associe uma varredura existente ou inicie uma nova na página de Varreduras',
    noHosts: 'Sem hosts',
    noVulnerabilities: 'Sem vulnerabilidades',
    noAttackPaths: 'Sem caminhos de ataque',
    // Network stats
    vulnerable: 'Vulneráveis',
    subnets: 'Sub-redes',
    services: 'Serviços',
    noAttackTree: 'Sem árvore de ataque',
    noVPN: 'Sem VPN configurado',
    // AI Analysis
    aiAnalysis: 'Análise IA',
    generateSummary: 'Gerar resumo',
    launchAiAnalysis: 'Iniciar análise IA',
    analysisInProgress: 'Análise em curso...',
    completeAnalysis: 'Análise completa e Soluções',
    aggregatedData: 'Dados agregados',
    riskAnalysis: 'Análise de riscos',
    clickToGenerateSummary: 'Clique em "Gerar resumo" para obter uma análise IA',
    noAnalysisAvailable: 'Nenhuma análise disponível',
    clickToLaunchAnalysis: 'Clique no botão acima para iniciar a análise IA',
    launchScanToDiscoverNetwork: 'Inicie uma verificação para descobrir a rede',
    critical: 'Críticas',
    high: 'Altas',
    download: 'Descarregar',
    deleteStoredCredentials: 'Eliminar credenciais guardadas',
    useStoredCredentials: 'usar credenciais guardadas',
    enterVpnUsername: 'Introduza o seu nome de utilizador VPN',
    enterVpnPassword: 'Introduza a sua palavra-passe VPN',
    // VPN Modal
    actionPlan: 'Plano de ação & Soluções',
    noDocuments: 'Nenhum documento gerado para este workspace',
    reportsWillAppear: 'Os relatórios aparecerão aqui após a geração',
    vpnCredentials: 'Credenciais VPN',
    requiresAuthentication: 'requer autenticação',
    storedCredentials: 'Credenciais guardadas',
    clickToUseCredentials: 'Clique em "Conectar" para usar estas credenciais',
    connect: 'Conectar',
    cancel: 'Cancelar',
    username: 'Nome de utilizador',
    password: 'Palavra-passe',
    saveCredentials: 'Guardar estas credenciais',
    saveCredentialsSecurely: 'Guardar credenciais de forma segura',
    credentialsStorageInfo: 'As credenciais serão encriptadas (AES-256) e armazenadas na base de dados. Serão automaticamente utilizadas em futuras conexões VPN.',
    saving: 'A guardar...',
    connecting: 'A conectar...',
    server: 'Servidor',
    protocol: 'Protocolo',
    noVulnsToFix: 'Nenhuma vulnerabilidade a corrigir',
    connectionInProgress: 'Conexão em curso...',
    connectionFailed: 'Conexão falhada',
    generateActionPlan: 'Gerar plano de ação',
    clickToGenerateActionPlan: 'Clique em "Gerar plano de ação" para obter recomendações',
    vpnConnected: 'VPN conectada! IP:',

    // Workspace Switcher
    selectTitle: 'Selecionar espaço de trabalho',
    selectDescription: 'Escolha um espaço de trabalho para continuar',
    searchPlaceholder: 'Pesquisar espaços de trabalho...',
    noWorkspacesYet: 'Ainda não há espaços de trabalho',
    noResults: 'Nenhum espaço de trabalho correspondente',
    createFirst: 'Criar o seu primeiro espaço de trabalho',
    createNew: 'Criar novo',
    continue: 'Continuar',
    switchError: 'Erro ao mudar de espaço de trabalho',
    scan: 'análise',
    scans: 'análises',
    select: 'Selecionar espaço de trabalho',
    manageAll: 'Gerir espaços de trabalho',
    noWorkspaces: 'Nenhum espaço de trabalho encontrado',
    switching: 'A mudar...',
    switchSuccess: 'Espaço de trabalho alterado com sucesso',
    autoSelected: 'Espaço de trabalho selecionado automaticamente',
    pleaseSelect: 'Por favor selecione um espaço de trabalho para continuar',
    activeWorkspace: 'Espaço de trabalho ativo',
    subtitle: 'Gerencie seus espaços de clientes e suas configurações',
    deleteWorkspaceError: 'Erro ao eliminar o espaço',
    deleteWorkspaceSuccess: 'Espaço eliminado com sucesso',
    invalidIdentifier: 'Por favor introduza um identificador válido',
    workspaceName: 'Nome do espaço',
    companyName: 'Nome da empresa',
    searchCompany: 'Pesquisar uma empresa',
    postalCode: 'Código postal',
    nafCode: 'Código NAF',
    capital: 'Capital',
    employees: 'Efetivo',
    companyLogo: 'Logo da empresa',
    noLogo: 'Sem logo',
    vpnConfiguration: 'Configuração VPN',
    contractStatus: 'Estado do contrato',
    sendContract: 'Enviar o contrato',
    readyForTests: 'Pronto para os testes',
    upload: 'Carregar',
    country: 'País',
    contractNotSigned: 'Contrato não assinado',
    siret: 'SIRET',
    siretPlaceholder: 'Ex: 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Ex: 123 456 789',
    analyzingInProgress: 'Análise em curso...',
    generatingAiSummary: 'Geração do resumo IA',
    noScansToAssociate: 'Nenhuma varredura disponível para associar',
    associateScan: 'Associar uma varredura',
    networkMap: 'Mapa de Rede',
    // Contact form labels
    contactFullName: 'Nome completo',
    contactFunction: 'Função',
    contactEmail: 'E-mail',
    contactPhone: 'Telefone',
    contactResponsibleDescription: 'Pessoa responsável pelo projeto pentest',
    logoUsedInReports: 'Utilizado nos relatórios de pentest',
    // Schedules
    scanSchedules: 'Agendamentos de varredura',
    addSchedule: 'Adicionar agendamento',
    noSchedules: 'Sem agendamentos configurados',
    noSchedulesHint: 'Clique em "Adicionar agendamento" para automatizar as suas varreduras',
    createSchedule: 'Criar agendamento',
    scheduleName: 'Nome do agendamento',
    scheduleNamePlaceholder: 'Ex: Varredura semanal de segurança',
    targets: 'Alvos',
    targetsPlaceholder: '192.168.1.0/24, exemplo.com',
    targetsCommaSeparated: 'Alvos * (separados por vírgulas)',
    scanType: 'Tipo de varredura',
    frequency: 'Frequência',
    timeOfDay: 'Hora de execução',
    daysOfWeek: 'Dias da semana',
    autoGenerateReport: 'Gerar o relatório automaticamente',
    sendNotifications: 'Enviar notificações',
    notificationRecipients: 'Destinatários das notificações (e-mails, separados por vírgulas)',
    creating: 'Criando...',
    // Scan types
    scanTypeQuick: 'Rápida',
    scanTypeFull: 'Completa',
    scanTypeVulnerability: 'Vulnerabilidades',
    scanTypePortScan: 'Varredura de portas',
    scanTypeWebScan: 'Varredura Web',
    // Frequencies
    frequencyDaily: 'Diária',
    frequencyWeekly: 'Semanal',
    frequencyBiweekly: 'Quinzenal',
    frequencyMonthly: 'Mensal',
    frequencyQuarterly: 'Trimestral',
    // Days
    dayMon: 'Seg',
    dayTue: 'Ter',
    dayWed: 'Qua',
    dayThu: 'Qui',
    dayFri: 'Sex',
    daySat: 'Sáb',
    daySun: 'Dom',
    // Stats labels
    schedulesCount: 'Agendamentos',
    successfulRuns: 'Execuções bem-sucedidas',
    runNow: 'Executar agora',
    nextRun: 'Próxima',
    // Remediation Tracker
    remediationTitle: 'Acompanhamento de Remediação',
    remediationProgress: 'Progresso global',
    remediationVulnsFixed: 'vulnerabilidades remediadas',
    remediationNoVulns: 'Nenhuma vulnerabilidade encontrada',
    remediationRescanTitle: 'Iniciar uma nova varredura de verificação',
    remediationAllStatuses: 'Todos os estados',
    remediationAllSeverities: 'Todas as gravidades',
    remediationResults: 'resultados',
    remediationSeverity: 'Gravidade',
    remediationVulnerability: 'Vulnerabilidade',
    remediationHost: 'Host',
    remediationStatus: 'Estado',
    remediationUpdated: 'Atualizado',
    remediationActions: 'Ações',
    remediationPrevious: '← Anterior',
    remediationNext: 'Próximo →',
    remediationCritical: 'Crítica / Alta — não tratadas',
    remediationSeverityBreakdown: 'Distribuição por gravidade',
    remediationStatusUpdate: 'Estado atualizado',
    remediationStatusError: 'Erro ao atualizar',
    remediationLoadDashboardError: 'Erro ao carregar painel',
    remediationLoadVulnsError: 'Erro ao carregar vulnerabilidades',
    remediationRefresh: 'Atualizar',
    remediationCertificate: 'Certificado de encerramento',
    remediationSearch: 'Pesquisar...',
    // Status labels
    statusOpen: 'Aberta',
    statusInProgress: 'Em curso',
    statusFixed: 'Corrigida (a verificar)',
    statusVerified: 'Verificada ✓',
    statusAcceptedRisk: 'Risco aceite',
    statusWontFix: 'Não será corrigida',
    // Severity labels
    severityCritical: 'Crítica',
    severityHigh: 'Alta',
    severityMedium: 'Média',
    severityLow: 'Baixa',
    severityInfo: 'Info',
    // KPI labels
    kpiOpen: 'Abertas',
    kpiInProgress: 'Em curso',
    kpiToVerify: 'A verificar',
    kpiVerified: 'Verificadas',
    kpiAcceptedRisk: 'Risco aceite',
    kpiTotal: 'Total',
    // VPN
    saveUid: 'Guardar o UID',
    noVpnCredentials: 'Sem credenciais VPN guardadas - conecte-se para guardar',
    noVpnRoutes: 'Sem rotas personalizadas configuradas',
    add: 'Adicionar',
    noScanReports: 'Sem relatórios de varredura disponíveis',
    errorAnalysis: 'Erro de análise',
    noBusinessAnalysis: 'Sem análise de negócio disponível',
    noVpnConfig: 'Sem configuração VPN',
    deleteReport: 'Eliminar o relatório',
    vpnRouteCount: '{{count}} rota(s)',
    noRoutes: 'Sem rotas',
    // WorkspaceManager
    deleteVpnLogo: 'Eliminar o logo',
    modifyWorkspace: 'Modificar o workspace',
    modifyWorkspaceDesc: 'Modificar as informações do cliente "{{name}}"',
    modifyVpnDesc: 'Modificar a VPN associada para as varreduras deste cliente',
    noVpnRequired: 'Sem configuração VPN necessária',
    noVpnAvailable: 'Sem configuração VPN disponível',
    createWorkspaceBtn: 'Criar o workspace',
    vpnUploadError: 'Erro ao carregar a VPN',
    companyNotFound: 'Nenhuma empresa encontrada para "{{term}}"',
    noCompanyFound: 'Nenhuma empresa encontrada',
    companySearchError: 'Erro durante a pesquisa',
    scheduleError: 'Erro ao agendar a varredura',
    noCompletedScans: 'Sem varreduras concluídas',
    allWorkspaces: 'Todos os workspaces',
    contractCreateError: 'Erro ao criar o contrato',
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnerabilidades',
    subtitle: 'Análise e gestão de vulnerabilidades detetadas',
    vulnerability: 'Vulnerabilidade',
    severity: 'Gravidade',
    severities: {
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Média',
      low: 'Baixa',
      info: 'Informativa'
    },
    cve: 'CVE',
    cvss: 'Pontuação CVSS',
    affected: 'Afetado',
    solution: 'Solução',
    references: 'Referências',
    evidence: 'Evidência',
    exploitable: 'Explorável',
    verified: 'Verificada',
    falsePositive: 'Falso positivo',
    validation: {
      confirmed: 'Confirmado explorável',
      theoretical: 'Teórico',
      not_exploitable: 'Não explorável',
      unvalidated: 'Não validado',
      poc_title: 'Prova de Conceito',
      narrative: 'Narrativa de exploração',
      exploit_path: 'Caminho de exploração',
      prerequisites: 'Pré-requisitos',
    },
    markAsFixed: 'Marcar como corrigida',
    noVulnerabilities: 'Nenhuma vulnerabilidade encontrada',
    export: 'Exportar vulnerabilidades',
    distributionBySeverity: 'Distribuição por Gravidade',
    priority: {
      auto: 'Automático',
    },
    // Attack Chain
    attackChain: {
      title: 'Classificação de Cadeias de Ataque',
      subtitle: 'Análise de riscos multi-vulnerabilidades para penetrar o alvo',
      riskScore: 'Pontuação de risco',
      vulnCount: 'vulnerabilidades',
      attackPath: 'Caminho de ataque até o objetivo',
      // Chart
      chartTitle: 'Distribuição de Vulnerabilidades',
      chartSubtitle: 'Análise estatística de CVEs detectadas',
      bySeverity: 'Distribuição por Severidade',
      keyMetrics: 'Métricas Chave',
      totalVulns: 'Total CVE',
      avgCvss: 'CVSS Médio',
      criticalHigh: 'Crítico + Alto',
      affectedHosts: 'Hosts Afetados',
      topCves: 'Top CVE por CVSS',
      // Stages
      stages: {
        initialAccess: 'Acesso Inicial',
        privEscalation: 'Escalação de Privilégios',
        persistence: 'Persistência',
        objective: 'Objetivo'
      },
      exploitVia: 'Exploração via',
      escalationVia: 'Escalação via',
      maintenanceVia: 'Persistência via',
      fullCompromise: 'Comprometimento completo do sistema',
      adminAccess: 'Acesso admin possível',
      initialSystemAccess: 'Acesso inicial ao sistema',
      // Risk Factors
      riskFactors: 'Fatores de risco',
      factors: {
        multiVuln: 'Multi-vulnerabilidades',
        multiVuln5: '{count} vulns encadeáveis',
        multiVuln3: '{count} vulns neste host',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potencial',
        authBypass: 'Bypass auth possível',
        privEsc: 'Escalação de privilégios',
        exposed: 'Serviços expostos',
        highCvss: 'CVSS médio {score}'
      },
      // Ratings
      ratingCritical: 'CRÍTICO',
      ratingHigh: 'ALTO',
      ratingMedium: 'MÉDIO',
      ratingLow: 'BAIXO',
      ratingSafe: 'SEGURO',
      // Details
      criticalPath: 'CAMINHO CRÍTICO',
      vulnsInChain: 'Vulnerabilidades nesta cadeia',
      noChains: 'Nenhuma cadeia de ataque detectada',
      noVulnsDesc: 'Nenhuma vulnerabilidade encontrada para analisar caminhos de ataque.',
      viewDetails: 'Ver detalhes',
      multiVulnWarning: 'Risco aumentado: múltiplas vulnerabilidades encadeáveis',
      // Recommendations
      recommendation: 'Recomendação de exploração',
      recoCritical: 'Este alvo apresenta um risco crítico. A combinação de {count} vulnerabilidades permite comprometimento completo do sistema. Prioridade máxima para remediação.',
      recoHigh: 'Alto risco de comprometimento. Vulnerabilidades combinadas oferecem um caminho de ataque viável. Ação corretiva recomendada o mais rápido possível.',
      recoMedium: 'Risco moderado. Algumas vulnerabilidades podem ser encadeadas para exploração. Monitorar e corrigir conforme prioridade.',
      recoLow: 'Risco baixo. Vulnerabilidades presentes têm impacto limitado e são difíceis de explorar em cadeia.',
      // Stats
      criticalPaths: 'Caminhos Críticos',
      highRisk: 'Risco Alto',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hosts Analisados',
      avgScore: 'Pontuação Média',
      // Info
      infoText: 'Esta classificação identifica os hosts mais vulneráveis analisando combinações de vulnerabilidades exploráveis para atingir objetivos de penetração.',
      // Legend
      legendCritical: 'Crítico (80-100)',
      legendHigh: 'Alto (60-79)',
      legendMedium: 'Médio (40-59)',
      legendLow: 'Baixo (20-39)',
      legendSafe: 'Seguro (0-19)',
      analysisTitle: 'Análise de Riscos',
    },
    aiAssistant: 'Assistente IA',
    aiAssistantDesc: 'Analise e explore vulnerabilidades de forma autônoma',
    searchPlaceholder: 'Buscar por título, CVE, descrição...',
    noVulnerabilitiesFound: 'Nenhuma vulnerabilidade encontrada nas varreduras.',
    noVulnerabilitiesBySeverity: 'Nenhuma vulnerabilidade de gravidade {severity} encontrada.',
    customActionPlaceholder: 'Ex: shell_reverso, extracao_creds, backdoor...',
    actionPanel: {
      title: 'Ações sobre a vulnerabilidade',
    },
    prioritization: 'Priorização',
    prioritizationDesc: 'Urgência e criticidade',
    exploitabilityLabel: 'Explorabilidade',
    exploitabilityDesc: 'Vulnerabilidades exploráveis',
    summaryLabel: 'Resumo',
    summaryDesc: 'Visão geral',
    remediationLabel: 'Remediação',
    remediationDesc: 'Plano de correção',
    aiQueryPlaceholder: 'Faça uma pergunta sobre as vulnerabilidades...',
    analyzeBtn: 'Analisar',
    pocAutoTitle: 'PoC Auto - Geração e Execução',
    pocSelectVuln: 'Selecionar uma vulnerabilidade',
    noCriticalHighForPoC: 'Nenhuma vulnerabilidade crítica/alta para PoC',
    pocGeneratedCode: 'Código PoC Gerado',
    copyCta: 'Copiar',
    executeBtn: 'Executar',
    executingBtn: 'Executando...',
    pocGenerating: 'Gerando o PoC...',
    pocSelectPrompt: 'Selecione uma vulnerabilidade para gerar um PoC',
    pocResult: 'Resultado:',
    pocActionInProgress: 'Ação em andamento...',
    hideAttackTree: 'Ocultar Árvore de Ataque',
    showAttackTree: 'Mostrar Árvore de Ataque',
    viewWorkspace: 'Ver Workspace',
    generatingAttackTree: 'Gerando a árvore de ataque...',
    noAttackTreeData: 'Nenhum dado disponível para a árvore de ataque',
    ensureWorkspaceHasScans: 'Certifique-se de que o workspace possui varreduras com vulnerabilidades',
    pageOfTotal: 'Página {current} / {total} — {count} vulnerabilidades',
    prevPage: '← Anterior',
    nextPage: 'Próximo →',
    quickActionsTitle: 'Ações Rápidas',
    newScanBtn: 'Nova varredura',
    generateReportBtn: 'Gerar relatório',
    exportJsonBtn: 'Exportar JSON',
    exportCsvBtn: 'Exportar CSV',
    aiAnalysisTitle: 'Análise IA',
    selectedLabel: 'Selecionado:',
    analyzingLabel: 'Analisando...',
    analyzeWithAI: 'Analisar com IA',
    impactLabel: 'Impacto',
    recommendationsLabel: 'Recomendações',
    selectVulnForAnalysis: 'Selecione uma vulnerabilidade para obter uma análise IA detalhada.',
    statisticsTitle: 'Estatísticas',
    cvssAvg: 'CVSS Médio',
    exploitableCount: 'Exploráveis',
    hostsAffected: 'Hosts Afetados',
    actionsHistory: 'Histórico de Ações ({count})',
    clearHistory: 'Limpar histórico',
    viewScan: 'Ver varredura',
    addToReport: 'Adicionar ao relatório',
    severityLabel: 'Gravidade',
    cveLabel: 'CVE',
    cvssLabel: 'CVSS',
    targetLabel: 'Alvo',
    actionsAvailable: 'Ações disponíveis',
    exploitAction: 'Exploração',
    exploitActionDesc: 'Tentar explorar esta vulnerabilidade para obter acesso',
    injectionAction: 'Injeção',
    injectionActionDesc: 'Executar uma injeção (SQL, comando, XSS, etc.)',
    enumerationAction: 'Enumeração',
    enumerationActionDesc: 'Coletar mais informações sobre esta falha',
    privescAction: 'Escalação',
    privescActionDesc: 'Tentar uma escalação de privilégios',
    pivotAction: 'Pivô',
    pivotActionDesc: 'Pivotar para outros sistemas da rede',
    exfilAction: 'Exfiltração',
    exfilActionDesc: 'Extrair dados sensíveis através desta falha',
    aiWizardBtn: 'Wizard IA',
    aiWizardDesc: 'A IA analisa o CVE e inicia o wizard de exploração adequado',
    captureProofBtn: 'Capturar Prova',
    captureProofDesc: 'Capturar uma prova de exploração para o relatório',
    customActionTitle: 'Ação personalizada',
    executeAction: 'Executar',
    actionsAutoIntegrated: 'Os resultados das ações serão automaticamente integrados no relatório da varredura',
    editPriority: 'Editar Prioridade',
    autoSeverity: 'Gravidade automática:',
    manualPriority: 'Prioridade manual',
    usesCVSS: 'Usa CVSS',
    priorityCritical: 'Crítica',
    priorityHigh: 'Alta',
    priorityMedium: 'Média',
    priorityLow: 'Baixa',
    priorityInfo: 'Info',
    noteOptional: 'Nota (opcional)',
    explainPriorityChange: 'Explique por que mudou a prioridade...',
    savePriority: 'Salvar',
    savingPriority: 'Salvando...',
    aiWizardTitle: 'Wizard IA - Análise de Vulnerabilidade',
    wizardRecommended: 'Wizard recomendado pela IA',
    vulnSummaryTitle: 'Resumo da vulnerabilidade',
    launchWizard: 'Lançar {name}',
    orChooseWizard: 'Ou escolher outro wizard:',
    aiAnalyzing: 'Analisando com IA...',
    aiDeterminingWizard: 'A IA determina o melhor wizard de exploração',
    screenshotsTitle: 'Capturas de Prova ({count})',
    noScreenshots: 'Nenhuma captura de prova',
    screenshotsAutoAdded: 'As capturas serão adicionadas automaticamente aos relatórios',
    wizardReasonAD: 'Esta vulnerabilidade está relacionada ao Active Directory, Kerberos ou serviços Windows. O wizard AD permite explorar falhas de autenticação e movimento lateral.',
    wizardReasonAPI: 'Esta vulnerabilidade diz respeito a uma API ou serviço web. O wizard API permite testar endpoints, autenticação e injeções.',
    wizardReasonIoT: 'Esta vulnerabilidade afeta um dispositivo IoT ou protocolo industrial. O wizard IoT é especializado na análise de objetos conectados.',
    wizardReasonOT: 'Esta vulnerabilidade diz respeito a um sistema industrial ou SCADA. O wizard OT é projetado para a análise segura de ambientes industriais.',
    wizardReasonExpert: 'Esta vulnerabilidade crítica requer uma análise aprofundada. O modo Expert oferece controle total sobre as técnicas de exploração.',
    wizardReasonAI: 'A IA analisará esta vulnerabilidade e determinará automaticamente a melhor estratégia de exploração.',
    aiSummaryTemplate: 'Esta vulnerabilidade {severity} afeta {target}. Potencialmente permite a um atacante explorar {title}.',
    aiImpactCritical: 'Impacto crítico na confidencialidade e integridade do sistema',
    aiImpactHigh: 'Impacto alto - requer atenção imediata',
    aiImpactMedium: 'Impacto moderado - corrigir o mais breve possível',
    aiImpactLow: 'Impacto baixo - monitorar',
    aiRec1: 'Aplicar os patches de segurança disponíveis',
    aiRec2: 'Restringir o acesso de rede ao serviço afetado',
    aiRec3: 'Implementar monitoramento reforçado',
    aiRec4CVE: 'Consultar os detalhes do CVE: {cve_id}',
    aiRec4NoCVE: 'Realizar uma análise aprofundada',
    aiExploitHigh: 'Alta',
    aiExploitMedium: 'Média',
    aiExploitLow: 'Baixa',
    aiExploitUnknown: 'Não avaliada',
    aiVectorRemote: 'Rede (Remoto)',
    aiVectorAdjacent: 'Adjacente',
    aiVectorLocal: 'Local',
    exploitabilityMetric: 'Explorabilidade',
    attackDifficulty: 'Dificuldade de ataque',
    detectionRisk: 'Risco de detecção',
    exploitMaturity: 'Maturidade do exploit',
    riskAssessment: 'Avaliação de risco',
    aiRecommendations: 'Recomendações IA',
    aiAnalyzingVuln: 'A IA está analisando a vulnerabilidade...',
    clickToGetRecommendations: 'Clique em "Ver" para obter as recomendações IA',
    autoAnalysisDesc: 'Análise automática de vetores de ataque e estratégias de exploração',
    analyzeLabel: 'Analisando...',
    viewLabel: 'Ver',
    generateExploit: 'Gerar',
    generatingExploit: 'Gerando...',
    executeOnTarget: 'Executar no alvo',
    executingExploit: 'Executando...',
    copyCode: 'Copiar',
    codeCopied: 'Código copiado para a área de transferência!',
    langLabel: 'Linguagem:',
    targetLabel2: 'Alvo:',
    aiGeneratingExploit: 'A IA gera um exploit personalizado...',
    aiExploitAnalysisDesc: 'Análise do CVE, criação do payload, otimização...',
    clickGenerateExploit: 'Clique em "Gerar" para criar um exploit IA personalizado',
    thenExecuteExploit: 'Depois "Executar no alvo" para lançar o ataque',
    autoExploitGenDesc: 'Geração automática de código de exploração adaptado ao alvo',
    exploitProofs: 'Provas de Exploração ({count})',
    captureN: 'Captura {n}:',
    capturesEnregistrees: '{count} capturas de prova registradas',
    exploitReussie: 'EXPLORAÇÃO BEM-SUCEDIDA',
    exploitEchec: 'FALHA',
    dureeDuration: 'Duração',
    exportPdf: 'Exportar PDF',
    impactAnalysis: 'Análise de Impacto',
    accessVector: 'Vetor de acesso',
    accessComplexity: 'Complexidade de acesso',
    requiredAuth: 'Autenticação requerida',
    userInteractionLabel: 'Interação do usuário',
    confidentialityImpact: 'Impacto na confidencialidade',
    integrityImpact: 'Impacto na integridade',
    availabilityImpact: 'Impacto na disponibilidade',
    networkInternet: 'Rede Internet',
    adjacentNetwork: 'Rede Adjacente',
    localAccess: 'Acesso Local',
    complexityLow: 'Baixa',
    complexityHigh: 'Alta',
    privNone: 'Nenhuma',
    privLow: 'Privilégios baixos',
    privHigh: 'Privilégios altos',
    userInteractionNone: 'Não requerida',
    userInteractionRequired: 'Requerida',
    impactFull: 'Completo',
    impactPartial: 'Parcial',
    impactNone: 'Nenhum',
    scoreCvss: 'Pontuação CVSS v3.1',
    detailsBtn: 'Detalhes',
    launchBtn: 'Lançar',
    relaunchBtn: 'Relançar',
    analyzingLabel2: 'Analisando...',
    remediationRecommendedDelay: 'Prazo recomendado',
    remediationMaxWindow: 'Janela máxima de correção',
    remediationImpact: 'Impacto',
    remediationHighImpact: 'ALTO',
    remediationRestartRequired: 'Reinicialização do serviço requerida',
    remediationStepsTitle: 'Passos de remediação detalhados',
    step1Title: 'Backup e preparação',
    step1Desc: 'Antes de qualquer modificação, faça um backup completo do sistema.',
    step1Li1: 'Verificar o espaço em disco disponível',
    step1Li2: 'Documentar a configuração atual',
    step1Li3: 'Notificar as equipes envolvidas',
    step2Title: 'Atualização do Apache Struts',
    step2Desc: 'Baixar e instalar a versão mais recente e segura do Apache Struts.',
    step2Warning: 'Atenção: Verifique a compatibilidade com sua aplicação antes da atualização',
    step3Title: 'Configuração WAF',
    step3Desc: 'Implementar regras WAF para bloquear tentativas de exploit OGNL.',
    step4Title: 'Hardening da configuração',
    step4Desc: 'Reforçar a configuração do Struts para prevenir futuras vulnerabilidades.',
    step5Title: 'Reinicialização e validação',
    step5Desc: 'Reinicializar os serviços e validar que a correção é efetiva.',
    step5Li1: 'Verificar que a aplicação inicia corretamente',
    step5Li2: 'Testar as funcionalidades críticas',
    step5Li3: 'Relançar uma varredura de vulnerabilidades para confirmar',
    step6Title: 'Monitoramento e vigilância',
    step6Desc: 'Implementar monitoramento contínuo para detectar tentativas de exploração.',
    step6Li1: 'Configurar alertas IDS/IPS para padrões de ataque Struts',
    step6Li2: 'Ativar o registro detalhado de requisições HTTP',
    step6Li3: 'Programar varreduras de vulnerabilidade regulares (semanais)',
    step6Li4: 'Subscrever-se aos boletins de segurança do Apache Struts',
    workaroundTitle: 'Solução temporária (se o patch não for possível)',
    workaroundDesc: 'Se a atualização imediata não for possível, aplicar estas medidas de mitigação:',
    workaround1: 'Bloquear o acesso externo ao serviço (firewall/ACL)',
    workaround2: 'Implementar um proxy reverso com filtragem de cabeçalhos Content-Type',
    workaround3: 'Desativar os endpoints REST não essenciais',
    workaround4: 'Ativar o modo estrito do parser multipart',
    attackDetails: 'Detalhes do Ataque',
    targetInfo: 'Alvo',
    systemInfoTitle: 'Informações do Sistema',
    hostnameLabel: 'Nome do host',
    architectureLabel: 'Arquitetura',
    ipLabel: 'Endereço IP',
    initialUserLabel: 'Usuário inicial',
    privilegesObtained: 'Privilégios obtidos',
    domainLabel: 'Domínio',
    exfiltratedData: 'Dados Exfiltrados ({count})',
    proofCaptures: 'Capturas de Prova ({count})',
    aiResponsesCount: '{count} resposta(s) IA',
    questionLabel: 'Pergunta:',
    discoveredField: 'Descoberto',
    aiExecAlert: 'Execução das recomendações IA em {host}:{port}\n\nTeste de penetração automatizado iniciado\nVarredura de vulnerabilidades em andamento\nVerificação de vetores de ataque\n\nResultados disponíveis em alguns minutos...',
    exploitSearchAlert: 'Busca e teste de exploits em {host}:{port}\n\nConectando ao Metasploit Framework\nVarredura de módulos aplicáveis\nTeste automatizado de exploits\n\n3 exploits encontrados, teste em andamento...',
    exploitGenAlert: 'Geração e execução de exploit IA em {host}:{port}\n\nAnálise da vulnerabilidade\nGeração do payload personalizado\nExecução no alvo\n\nResultado: Exploração bem-sucedida!\nSessão estabelecida.',
    screenshotInitialConn: 'Conexão inicial',
    screenshotInitialConnDesc: 'Estabelecimento da conexão reverse shell',
    screenshotSysInfo: 'Informações do sistema',
    screenshotSysInfoDesc: 'Recuperação das informações do alvo',
    screenshotFileAccess: 'Acesso a arquivos',
    screenshotFileAccessDesc: 'Prova de acesso ao sistema de arquivos',
    attackComplexity: 'Complexidade do ataque',
    attackVector: 'Vetor de ataque',
    cvssMetrics: 'Métricas CVSS',
    host: 'Host',
    immediateFix: 'Correção imediata',
    noCVE: 'Sem CVE',
    port: 'Porta',
    privilegesRequired: 'Privilégios necessários',
    remediation: 'Remediação',
    remediationSummary: 'Resumo de remediação',
    service: 'Serviço',
    sortByCvss: 'Ordenar por CVSS',
    sortBySeverity: 'Ordenar por gravidade',
    userInteraction: 'Interação do usuário',
    screenshotPrivEsc: 'Escalação de privilégios',
    screenshotPrivEscDesc: 'Tentativa de escalação de privilégios',
  },

  // Reports
  reports: {
    title: 'Relatórios',
    newReport: 'Novo relatório',
    generateReport: 'Gerar relatório',
    downloadReport: 'Descarregar relatório',
    reportType: 'Tipo de relatório',
    settings: 'Definições',
    branding: 'Branding',
    types: {
      executive: 'Relatório executivo',
      technical: 'Relatório técnico',
      compliance: 'Relatório de conformidade',
      full: 'Relatório completo',
      vulnerability_list: 'Relatório de vulnerabilidades',
      redteam: 'Relatório Red Team',
      retest: 'Relatório de retest',
      multi_campaign: 'Relatório multi-campanha',
      active_directory: 'Relatório Active Directory',
      data_leak: 'Relatório de vazamento de dados',
      attack_surface: 'Relatório de superfície de ataque'
    },
    format: 'Formato',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Texto (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Incluir evidências',
    includeRemediation: 'Incluir remediação',
    generatedAt: 'Gerado em',
    generatedBy: 'Gerado por',
    noReports: 'Sem relatórios',

    // Export modal
    export: {
      title: 'Exportação',
      processing: 'A exportar...',
      generating: 'A gerar ficheiro',
      takingLong: 'Esta operação está a demorar mais do que o esperado.',
      canWaitOrEmail: 'Pode aguardar ou fechar esta janela e enviaremos um link por e-mail.',
      sendByEmail: 'Receber por e-mail',
      continueWaiting: 'Também pode continuar a aguardar, o download começará automaticamente.',
      emailSent: 'E-mail enviado!',
      emailSentDesc: 'Receberá o link de download por e-mail dentro de momentos.',
      wordLocked: 'Disponível para planos Enterprise e superiores'
    },
    typeDescriptions: {
      executive: 'Síntese estratégica para o COMEX com indicadores-chave e recomendações prioritárias',
      technical: 'Análise completa de vulnerabilidades com detalhes técnicos e remediações',
      vulnerability_list: 'Exportação estruturada para Jira, ServiceNow, GLPI',
      redteam: 'Cenário de ataque narrativo com mapeamento MITRE ATT&CK',
      retest: 'Comparação antes/depois da correção',
      multi_campaign: 'Vista consolidada de várias análises',
      active_directory: 'Auditoria AD, privilégios, GPO, delegações',
      data_leak: 'Deteção de dados expostos e credenciais',
      attack_surface: 'Cartografia da exposição externa',
    },
    aiGenerated: 'Relatórios IA',
    generated: {
      title: 'Relatórios Gerados por IA',
      subtitle: 'Relatórios profissionais gerados por LLM',
      create: 'Criar um relatório',
      createNew: 'Novo relatório IA',
      selectType: 'Tipo de relatório',
      selectScan: 'Selecionar uma análise',
      selectWorkspace: 'Selecione um espaço de trabalho',
      selectFormat: 'Formato de saída',
      generating: 'Geração em curso...',
      regenerate: 'Regenerar',
      regenerateSection: 'Regenerar esta secção',
      export: 'Exportar',
      download: 'Descarregar',
      delete: 'Eliminar',
      confirmDelete: 'Tem a certeza de que deseja eliminar este relatório?',
      status: {
        pending: 'Pendente',
        queued: 'Na fila',
        generating: 'A gerar',
        completed: 'Concluído',
        failed: 'Falhado',
        cancelled: 'Cancelado',
      },
      sections: {
        executive_summary: 'Resumo executivo',
        key_findings: 'Conclusões principais',
        recommendations: 'Recomendações',
        technical_details: 'Detalhes técnicos',
        vulnerability_analysis: 'Análise de vulnerabilidades',
        risk_assessment: 'Avaliação de riscos',
        remediation_plan: 'Plano de remediação',
        attack_narrative: 'Narrativa de ataque',
        mitre_mapping: 'Mapeamento MITRE ATT&CK',
        timeline: 'Cronologia',
        appendix: 'Apêndices',
      },
      quality: {
        score: 'Pontuação de qualidade',
        excellent: 'Excelente',
        good: 'Bom',
        average: 'Médio',
        poor: 'Fraco',
      },
      noReports: 'Nenhum relatório gerado',
      noReportsDesc: 'Crie o seu primeiro relatório IA para começar',
      totalReports: 'Total de relatórios',
      completedReports: 'Relatórios concluídos',
      averageQuality: 'Qualidade média',
      lastGenerated: 'Último relatório',
    },
    placeholders: {
      footerText: 'Ex: Documento confidencial - Não distribuir',
      logoUrl: 'https://empresa.pt/logo.png',
      contactEmail: 'contacto@empresa.pt',
      sectionTitle: 'Título da secção...',
      sectionDescription: 'Descrição (opcional)...',
      contentTemplate: 'Introduza o modelo de conteúdo (Markdown suportado)...\n\nVariáveis disponíveis:\n{{scan.target}} - Alvo da análise\n{{scan.date}} - Data da análise\n{{vulnerabilities.count}} - Número de vulnerabilidades\n{{vulnerabilities.critical}} - Vulnerabilidades críticas',
    },
    config: {
      title: 'Configuração',
      subtitle: 'Configure os tipos de relatórios disponíveis e personalize o seu conteúdo',
      settingsTitle: 'Parâmetros dos relatórios',
      brandingTitle: 'Imagem de marca dos relatórios',
      defaultLanguage: 'Idioma predefinido',
      confidentialityLevel: 'Nível de confidencialidade',
      includeOptions: 'Opções de inclusão',
      includeLogo: 'Incluir o logo',
      includeTableOfContents: 'Incluir o índice',
      includeAppendices: 'Incluir os apêndices',
      includeMethodology: 'Incluir a metodologia',
      footerTextLabel: 'Texto do rodapé',
      logoUrlLabel: 'URL do logo',
      primaryColor: 'Cor principal',
      secondaryColor: 'Cor secundária',
      companyInfo: 'Informações da empresa (para os relatórios)',
      companyName: 'Nome da empresa',
      address: 'Endereço',
      contactEmail: 'E-mail de contacto',
      phone: 'Telefone',
      website: 'Website',
      sectionsTitle: 'Secções do relatório',
      addSection: 'Adicionar uma secção',
      noTypeSelected: 'Nenhum tipo selecionado',
      noTypeSelectedHint: 'Clique num tipo de relatório na lista para visualizar e personalizar as suas secções',
      sectionRequired: 'Secção obrigatória',
      sectionActive: 'Ativo',
      requiredBadge: 'Obrigatório',
      contentTemplateLabel: 'Modelo de conteúdo (Markdown suportado)',
      clickToAddTemplate: 'Clique para adicionar um modelo de conteúdo...',
      markdownHint: 'Use Markdown para a formatação. Variáveis: {{variable}}',
      noReportTypes: 'Nenhum tipo de relatório disponível',
      loadError: 'Erro ao carregar o relatório',
      loadingReport: 'A carregar o relatório...',
      loadDataError: 'Erro ao carregar os dados',
      loadSectionsError: 'Erro ao carregar as secções',
      deleteError: 'Erro ao eliminar',
      reorderError: 'Erro ao reordenar',
      addError: 'Erro ao adicionar',
      updateError: 'Erro ao atualizar',
      saveError: 'Erro ao guardar',
      downloadError: 'Erro ao descarregar',
      generateError: 'Erro ao gerar o relatório',
      regenerateError: 'Erro ao regenerar',
      noGeneratedFile: 'Nenhum ficheiro gerado',
      noScansAvailable: 'Nenhuma análise concluída disponível para gerar relatórios. Por favor realize uma análise primeiro.',
      noVulnsDetected: 'Nenhuma vulnerabilidade detetada nas análises. O plano de remediação estará vazio.',
      loadingPentests: 'A carregar os pentests...',
      noScanAvailable: '-- Nenhuma análise disponível --',
      networkError: 'Erro de rede. Verifique a sua ligação.',
    },
  },

  // Account
  account: {
    title: 'A minha conta',
    profile: 'Perfil',
    security: 'Segurança',
    subscription: 'Subscrição',
    billing: 'Faturação',
    credits: 'Créditos',
    notifications: 'Notificações',
    integrations: 'Integrações',
    referral: 'Referência',
    activity: 'Atividade',
    contracts: 'Contratos',

    // Profile section
    profileSection: {
      title: 'Informação do perfil',
      avatar: 'Foto de perfil',
      changeAvatar: 'Alterar foto',
      removeAvatar: 'Remover foto',
      firstName: 'Nome',
      lastName: 'Apelido',
      email: 'Email',
      phone: 'Telefone',
      company: 'Empresa',
      position: 'Cargo',
      timezone: 'Fuso horário',
      language: 'Idioma do portal',
      languageDescription: 'Escolha o idioma de exibição da interface',
      updateSuccess: 'Perfil atualizado com sucesso',
      updateError: 'Erro ao atualizar o perfil',
      languages: {
        fr: 'Francês',
        en: 'Inglês',
        es: 'Espanhol',
        de: 'Alemão',
        it: 'Italiano',
        pt: 'Português'
      }
    },

    // Security section
    securitySection: {
      title: 'Segurança da conta',
      changePassword: 'Alterar palavra-passe',
      currentPassword: 'Palavra-passe atual',
      newPassword: 'Nova palavra-passe',
      confirmPassword: 'Confirmar palavra-passe',
      passwordRequirements: 'A palavra-passe deve ter pelo menos 8 caracteres',
      twoFactorAuth: 'Autenticação de dois fatores',
      enable2FA: 'Ativar 2FA',
      disable2FA: 'Desativar 2FA',
      twoFactorEnabled: '2FA ativado',
      twoFactorDisabled: '2FA desativado',
      activeSessions: 'Sessões ativas',
      revokeSession: 'Revogar sessão',
      revokeAllSessions: 'Revogar todas as sessões',
      loginHistory: 'Histórico de sessões',
      lastLogin: 'Última sessão',
      apiKeys: 'Chaves API',
      generateApiKey: 'Gerar chave API',
      deleteApiKey: 'Eliminar chave API',
      passwordsNoMatch: 'As palavras-passe não coincidem',
      passwordChanged: 'Palavra-passe alterada',
      mfaConfigError: 'Erro de configuração MFA',
      invalidCode: 'Código inválido',
      apiKeyGenerated: 'Chave API gerada e copiada',
      confirmApiKeyGenerate: 'Gerar uma nova chave API? A antiga será invalidada.',
      enterMfaCode: 'Insira o seu código MFA para desativar',
      passwordCopied: 'Palavra-passe copiada para a área de transferência',
      generatePasswordFirst: 'Gere uma palavra-passe e verifique o seu número de telefone',
      smsSent: 'Palavra-passe enviada por SMS',
      smsError: 'Erro ao enviar o SMS',
      mfaEnabled: '2FA ativada',
      mfaDisabled: '2FA desativada',
      passwordApplied: 'Palavra-passe aplicada aos campos',
    },

    // Subscription section
    subscriptionSection: {
      title: 'Subscrição',
      currentPlan: 'Plano atual',
      planDetails: 'Detalhes do plano',
      features: 'Funcionalidades incluídas',
      usage: 'Utilização',
      limits: 'Limites',
      renewalDate: 'Data de renovação',
      cancelSubscription: 'Cancelar subscrição',
      upgradePlan: 'Melhorar plano',
      downgradePlan: 'Reduzir plano',
      plans: {
        free: 'Grátis',
        pro: 'Pro',
        enterprise: 'Empresarial',
        dedicated: 'Dedicado'
      }
    },


    // Notifications section
    notificationsSection: {
      title: 'Preferências de notificações',
      emailNotifications: 'Notificações por email',
      pushNotifications: 'Notificações push',
      scanCompleted: 'Análise concluída',
      scanFailed: 'Análise falhada',
      newVulnerability: 'Nova vulnerabilidade crítica',
      reportReady: 'Relatório pronto',
      securityAlerts: 'Alertas de segurança',
      weeklyDigest: 'Resumo semanal',
      marketingEmails: 'Emails de marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Integrações',
      connected: 'Ligado',
      notConnected: 'Não ligado',
      configure: 'Configurar',
      disconnect: 'Desligar',
      testConnection: 'Testar ligação',
      connectionSuccess: 'Ligação bem-sucedida',
      connectionFailed: 'Ligação falhada',
      availableIntegrations: 'Integrações disponíveis',
      myIntegrations: 'As minhas integrações'
    },

    // Referral section
    referralSection: {
      title: 'Programa de referência',
      referralLink: 'Link de referência',
      copyLink: 'Copiar link',
      shareLink: 'Partilhar link',
      inviteFriends: 'Convidar amigos',
      referralStats: 'Estatísticas de referências',
      totalReferrals: 'Total de referências',
      pendingReferrals: 'Referências pendentes',
      completedReferrals: 'Referências concluídas',
      earnedCredits: 'Créditos ganhos',
      inviteByEmail: 'Convidar por email',
      contacts: 'Contactos convidados',
      rewards: 'Recompensas',
      leaderboard: 'Classificação',
      inviteContact: 'Convidar um contacto',
      shareDescription: 'Partilhe este link para convidar novos utilizadores',
      loading: 'A carregar...',
      yourLevel: 'O seu nível',
      nextLevel: 'Próximo nível',
      creditsEarned: 'Créditos ganhos',
      conversionFunnel: 'Funil de conversão',
      invited: 'Convidados',
      clicked: 'Clicados',
      signedUp: 'Registados',
      converted: 'Convertidos',
      clickRate: 'Taxa de cliques',
      conversionRate: 'Taxa de conversão',
      perClick: 'Por clique',
      perSignup: 'Por registo',
      perProConversion: 'Por conversão Pro',
      noContacts: 'Nenhum contacto convidado',
      inviteFirstContact: 'Convide o seu primeiro contacto',
      contact: 'Contacto',
      creditsGenerated: 'Créditos gerados',
      topReferrers: 'Top Referenciadores',
      rank: 'Posição',
      user: 'Utilizador',
      tier: 'Nível',
      referrals: 'Referências',
      conversions: 'Conversões',
      value: 'Valor',
      you: '(você)',
      firstName: 'Nome próprio',
      lastName: 'Apelido',
      company: 'Empresa',
      sendInvitation: 'Enviar convite',
      referralLinkCopied: 'Link de referência copiado!',
      invitationSent: 'Convite enviado com sucesso!',
      contactRemoved: 'Contacto removido',
      deleteContactConfirm: 'Eliminar este contacto?',
      resendInvitation: 'Reenviar convite',
      statusInvited: 'Convidado',
      statusClicked: 'Clicado',
      statusSignedUp: 'Registado',
      statusConverted: 'Convertido',
      statusChurned: 'Abandonou',
      remainingToNextTier: 'restantes',
      errorSending: 'Erro ao enviar convite',
      errorResending: 'Erro ao reenviar convite',
      errorDeleting: 'Erro ao eliminar contacto',
      planSubscribed: 'Subscrição ao plano {plan} bem-sucedida',
      packPurchased: 'Compra do pacote {pack} bem-sucedida'
    },

    // Save buttons
    // Avatar section
    avatarSection: {
      invalidType: 'Por favor selecione uma imagem',
      tooLarge: 'A imagem não deve exceder 2 MB',
      updateSuccess: 'Avatar atualizado',
      updateError: 'Erro ao atualizar o avatar',
      readError: 'Erro ao ler o ficheiro'
    },

    // Company section
    companySection: {
      title: 'Informações da empresa',
      logo: 'Logótipo da empresa',
      name: 'Nome da empresa',
      legalForm: 'Forma jurídica',
      capital: 'Capital social',
      address: 'Morada',
      city: 'Cidade',
      postalCode: 'Código postal',
      country: 'País',
      timezone: 'Fuso horário (para as análises)',
      legalRep: 'Representante legal',
      fullName: 'Nome completo',
      updateSuccess: 'Informações da empresa atualizadas',
      updateError: 'Erro ao guardar'
    },

    // Team section
    teamSection: {
      confirmRemove: 'Tem a certeza de que pretende remover este membro?',
      memberRemoved: 'Membro removido'
    },

    // Logo section
    logoSection: {
      updated: 'Logótipo atualizado',
      updatedAV: 'Logótipo atualizado - Análise antivírus OK',
      updateError: 'Erro ao atualizar o logótipo',
      deleted: 'Logótipo eliminado',
      deleteError: 'Erro ao eliminar o logótipo'
    },

    configuration: 'Configuração',
    team: 'Equipa',
    users: 'Utilizadores',
    help: 'Ajuda',
    history: 'Histórico',
    version: 'Versão',
    support: 'Suporte',
    reportTypes: 'Tipos de relatórios',
    loadError: 'Erro ao carregar a conta',
    saveAll: 'Guardar tudo',
    saveProfile: 'Guardar perfil',
    saveCompany: 'Guardar empresa',

    // Credits section
    creditsSection: {
      title: 'Gestão de créditos',
      subtitle: 'Gira os seus créditos, subscrições e pacotes',
      balance: 'Saldo',
      totalCredits: 'Créditos totais',
      monthlyCredits: 'Créditos mensais',
      packCredits: 'Créditos do pacote',
      usedThisMonth: 'Usados este mês',
      remaining: 'Restantes',
      buyCredits: 'Comprar créditos',
      creditHistory: 'Histórico de créditos',
      transaction: 'Transação',
      amount: 'Montante',
      creditCosts: 'Custos das operações',
      scanCost: 'Custo da análise',
      reportCost: 'Custo do relatório',
      expires: 'Expira em',
      noExpiration: 'Sem expiração',
      currentPlan: 'Plano atual',
      statusActive: 'Ativo',
      monthlyPlans: 'Planos mensais',
      free: 'Grátis',
      perMonth: '/mês',
      creditsPerMonth: 'créditos/mês',
      unlimitedWorkspaces: 'Espaços de clientes ilimitados',
      externalScans: 'Análises externas',
      internalScans: 'Análises internas',
      adScans: 'Análises Active Directory',
      select: 'Selecionar',
      creditPacks: 'Pacotes de créditos',
      credits: 'créditos',
      validity: 'Validade',
      months: 'meses',
      buy: 'Comprar',
      scans: 'Análises',
      leakDetection: 'Deteção de fugas',
      audits: 'Auditorias',
      reports: 'Relatórios',
      noTransactions: 'Sem transações',
      transactionHistory: 'Histórico de transações',
      refresh: 'Atualizar',
      date: 'Data',
      type: 'Tipo',
      dashboard: 'Painel',
      plansAndPacks: 'Planos & Pacotes',
      history: 'Histórico',
      errorOccurred: 'Ocorreu um erro',
      creditsAvailable: 'créditos disponíveis',
      confirmPlanChange: 'Confirmar alteração de plano',
      confirmPurchase: 'Confirmar compra',
      planActiveImmediately: 'O plano ficará ativo imediatamente',
      creditsAddedImmediately: 'Os créditos serão adicionados imediatamente',
      cancel: 'Cancelar',
      processing: 'A processar...',
      confirm: 'Confirmar',
      planSubscribed: 'Subscrição ao plano {plan} bem-sucedida',
      packPurchased: 'Compra do pacote {pack} bem-sucedida',
      statusPremium: 'PREMIUM',
      statusExhausted: 'ESGOTADO',
      statusCritical: 'CRÍTICO',
      statusLow: 'BAIXO',
      unlimited: 'Ilimitado',
      totalBalance: 'Saldo total disponível',
      monthly: 'Mensais',
      packs: 'Pacotes'
    }
  },

  // Settings
  settings: {
    title: 'Definições',
    general: 'Geral',
    tools: 'Ferramentas',
    network: 'Rede',
    advanced: 'Avançado',

    // General settings
    generalSection: {
      title: 'Definições gerais',
      defaultScanType: 'Tipo de análise padrão',
      defaultReportFormat: 'Formato de relatório padrão',
      autoSaveReports: 'Guardar relatórios automaticamente',
      enableNotifications: 'Ativar notificações',
      darkMode: 'Modo escuro',
      compactView: 'Vista compacta'
    },

    // Tools settings
    toolsSection: {
      title: 'Configuração de ferramentas',
      enabledTools: 'Ferramentas ativadas',
      toolSettings: 'Definições da ferramenta',
      timeout: 'Tempo limite',
      threads: 'Número de threads',
      verbosity: 'Nível de detalhe'
    },

    // Network settings
    networkSection: {
      title: 'Configuração de rede',
      proxySettings: 'Definições de proxy',
      vpnSettings: 'Definições de VPN',
      dnsSettings: 'Definições de DNS',
      useProxy: 'Usar proxy',
      proxyHost: 'Host do proxy',
      proxyPort: 'Porta do proxy'
    },

    // Server status
    uptime: 'Tempo de atividade'
  },

  // Admin
  admin: {
    title: 'Administração',
    users: 'Utilizadores',
    companies: 'Empresas',
    system: 'Sistema',
    logs: 'Registos',
    maintenance: 'Manutenção',

    // Users management
    usersSection: {
      title: 'Gestão de utilizadores',
      addUser: 'Adicionar utilizador',
      editUser: 'Editar utilizador',
      deleteUser: 'Eliminar utilizador',
      activateUser: 'Ativar utilizador',
      deactivateUser: 'Desativar utilizador',
      resetPassword: 'Redefinir palavra-passe',
      role: 'Função',
      roles: {
        admin: 'Administrador',
        user: 'Utilizador',
        viewer: 'Visualizador'
      },
      lastLogin: 'Última sessão',
      createdAt: 'Criado em',
      noUsers: 'Sem utilizadores'
    },

    // System
    systemSection: {
      title: 'Sistema',
      systemInfo: 'Informação do sistema',
      version: 'Versão',
      uptime: 'Tempo de atividade',
      restart: 'Reiniciar',
      backup: 'Cópia de segurança',
      restore: 'Restaurar',
      update: 'Atualizar'
    }
  },

  // Errors
  errors: {
    generic: 'Ocorreu um erro',
    notFound: 'Página não encontrada',
    unauthorized: 'Acesso não autorizado',
    forbidden: 'Acesso proibido',
    serverError: 'Erro do servidor',
    networkError: 'Erro de rede',
    timeout: 'Tempo limite do pedido',
    validation: 'Erro de validação',
    invalidEmail: 'Email inválido',
    invalidPassword: 'Palavra-passe inválida',
    passwordMismatch: 'As palavras-passe não coincidem',
    requiredField: 'Este campo é obrigatório',
    minLength: 'Mínimo de {min} caracteres necessários',
    maxLength: 'Máximo de {max} caracteres permitidos',
    fillAllFields: 'Por favor preencha todos os campos obrigatórios',
    emailAlreadyUsed: 'Este email já está em uso',
    companyAlreadyRegistered: 'Esta empresa já está registrada',
    registrationError: 'Erro durante o registro',
    genericError: 'Ocorreu um erro inesperado',
    disposableEmailNotAllowed: 'Emails descartáveis não são permitidos',
    personalEmailNotAllowed: 'O email {domain} não é permitido. Use um email profissional.',
    invalidResetLink: 'Este link de redefinição é inválido ou expirou. Por favor, solicite um novo link.',
    resetLinkExpired: 'Este link de redefinição expirou. Por favor, solicite um novo link.',
    resetPasswordFailed: 'Falha na redefinição da senha. Por favor, tente novamente.',
    passwordCriteriaNotMet: 'A senha não atende a todos os critérios necessários.',
    backendMessages: {
      'Workspace not found': 'Espaço de trabalho não encontrado',
      'Invalid signature token': 'Token de assinatura inválido',
      'Contract already signed': 'Contrato já assinado',
      'Contract already pending signature. Cancel existing request first.': 'Contrato já aguarda assinatura. Cancele primeiro o pedido existente.',
      'Contract not yet signed': 'Contrato ainda não assinado',
      'Signed contract file not found': 'Ficheiro do contrato assinado não encontrado',
      'Contract file not found on disk': 'Ficheiro do contrato não encontrado no disco',
      'Contract already signed, cannot cancel': 'Contrato já assinado, impossível cancelar',
      'No pending signature request to cancel': 'Nenhum pedido de assinatura pendente para cancelar',
      'User not found': 'Utilizador não encontrado',
      'Invalid credentials': 'Credenciais inválidas',
      'Access denied': 'Acesso negado',
      'Permission denied': 'Permissão negada',
      'Not found': 'Não encontrado',
      'Bad request': 'Pedido inválido',
      'Internal server error': 'Erro interno do servidor',
      'Service unavailable': 'Serviço indisponível'
    },
    verificationFailed: 'A verificação do email falhou. O link pode estar expirado ou inválido.',
    invalidVerificationLink: 'Este link de verificação é inválido ou expirou. Por favor solicite um novo link.',
    rateLimitExceeded: 'Demasiadas tentativas. Por favor tente novamente dentro de alguns minutos.',
    rateLimitEmail: 'Por favor aguarde alguns minutos antes de reenviar um email de verificação.',
    401: {
      title: 'Não Autorizado',
      subtitle: 'Oops! Precisa de fazer login',
      description: 'A sua sessão expirou ou não está autenticado. Por favor inicie sessão para aceder a esta página.',
      redirectText: 'A redirecionar para o login'
    },
    403: {
      title: 'Acesso Negado',
      subtitle: 'Oops! Acesso proibido',
      description: 'Não tem as permissões necessárias para aceder a este recurso.',
      redirectText: 'A redirecionar para o painel'
    },
    404: {
      title: 'Página Não Encontrada',
      subtitle: 'Oops! Página inexistente',
      description: 'A página que procura não existe ou foi movida.',
      redirectText: 'A redirecionar para o painel'
    },
    500: {
      title: 'Erro do Servidor',
      subtitle: 'Oops! Ocorreu um erro',
      description: 'O servidor encontrou um erro. Por favor tente novamente dentro de momentos.',
      redirectText: 'A redirecionar para o painel'
    },
    503: {
      title: 'Serviço Indisponível',
      subtitle: 'Oops! Serviço temporariamente indisponível',
      description: 'O serviço está temporariamente indisponível para manutenção. Por favor tente novamente dentro de momentos.',
      redirectText: 'A redirecionar para o painel'
    },
    backToDashboard: 'Voltar ao Painel',
    retry: 'Tentar novamente',
    supportContact: 'Se o problema persistir, contacte o suporte técnico.',
    redirectingIn: 'em',
    seconds: 'segundos',
    error: 'Erro',
    companyRequired: 'Deve pertencer a uma empresa para executar esta ação',
    selectRequired: 'Por favor faça uma seleção',
    sessionExpired: 'Sessão expirada. Por favor inicie sessão novamente.'
  },

  // Success messages
  success: {
    saved: 'Guardado com sucesso',
    deleted: 'Eliminado com sucesso',
    updated: 'Atualizado com sucesso',
    created: 'Criado com sucesso',
    copied: 'Copiado para a área de transferência',
    sent: 'Enviado com sucesso',
    uploaded: 'Carregado com sucesso'
  },

  // Time
  time: {
    now: 'Agora',
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'dias',
    weeks: 'semanas',
    months: 'meses',
    years: 'anos',
    ago: 'há',
    in: 'em'
  },

  // Credentials
  credentials: {
    title: 'Credenciais',
    username: 'Nome de usuário',
    password: 'Senha',
    hash: 'Hash',
    domain: 'Domínio',
    source: 'Fonte',
    foundAt: 'Encontrado em',
    noCredentials: 'Nenhuma credencial encontrada',
    export: 'Exportar credenciais',
    addNumbers: 'Adicionar números',
    addSpecialChars: 'Caracteres especiais',
    noPasswordSave: 'Nenhuma palavra-passe para guardar',
    saveDictionaryError: 'Erro ao guardar o dicionário',
    loadDictionariesError: 'Erro ao carregar os dicionários',
    loadDictionaryError: 'Erro ao carregar o dicionário',
    deleteError: 'Erro ao eliminar',
    downloadError: 'Erro ao descarregar',
    searchError: 'Pesquisa falhada',
    validationError: 'Erro de validação',
    noCredentialExport: 'Nenhuma credencial para exportar',
    noPasswordExport: 'Nenhuma palavra-passe para exportar',
    decryptError: 'Erro ao desencriptar',
    noDictionarySaved: 'Nenhum dicionário guardado',
    noWorkspace: '-- Nenhum workspace --',
    noResult: 'Nenhum resultado',
    noResultMatch: 'Nenhuma credencial corresponde',
    noPasswordAvailable: 'Nenhuma palavra-passe disponível'
  },

  // Sessions
  sessions: {
    title: 'Sessões',
    sessionDetails: 'Detalhes da sessão',
    activeSession: 'Sessão ativa',
    closedSession: 'Sessão fechada',
    sessionType: 'Tipo de sessão',
    target: 'Alvo',
    startedAt: 'Iniciado em',
    endedAt: 'Finalizado em',
    duration: 'Duração',
    commands: 'Comandos',
    noSessions: 'Sem sessões',
    closeSession: 'Fechar sessão',
    quickActions: 'Ações rápidas',
    quickCommands: 'Comandos rápidos',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Sessão',
    pageTitle: 'Sessões de Exploração',
    pageDescription: 'Gestão de sessões de exploração e acessos comprometidos',
    interactiveShell: 'Terminal interativo',
    manualExploit: 'Manual',
    platform: 'Plataforma',
    platformUnknown: 'Desconhecida',
    exploitUsed: 'Exploit utilizado',
    commandsExecuted: 'Comandos executados',
    status: {
      active: 'Ativa',
      inactive: 'Inativa',
      closed: 'Fechada',
      stale: 'A relançar',
      idle: 'Em espera',
      error: 'Erro',
      unknown: 'Desconhecida',
      queued: 'Na fila de espera',
      running: 'Em execução',
      pending: 'Pendente',
      completed: 'Concluída',
      failed: 'Falhada'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTENTE'
    },
    persistence: {
      installed: 'Instalada',
      notInstalled: 'Não instalada'
    },
    quickPrompts: {
      help: 'Ajuda',
      privesc: 'Privesc',
      persistence: 'Persistência',
      lateral: 'Movimento lateral',
      pocAuto: 'PoC auto',
      aptModules: 'Módulos APT'
    },
    errors: {
      connectionError: 'Erro de ligação ao servidor',
      loadingError: 'Erro ao carregar as sessões',
      actionError: 'Erro ao executar a ação',
      serverError: 'Erro interno do servidor',
      serviceUnavailable: 'Serviço temporariamente indisponível',
      loadFailed: 'Falha ao carregar',
      screenshotFailed: 'Falha na captura de ecrã',
      privescFailed: 'Falha na escalada de privilégios',
      persistenceFailed: 'Falha na instalação da persistência',
      aptExecutionFailed: 'Falha na execução do módulo APT'
    },
    actions: {
      screenshotSuccess: 'Captura de ecrã efetuada',
      privescSuccess: 'Escalada de privilégios bem-sucedida',
      privescCompleted: 'Tentativa de escalada concluída',
      persistenceSuccess: 'Mecanismo de persistência instalado',
      persistenceCompleted: 'Instalação concluída'
    },
    privilegeLevel: 'Nível de privilégio',
    lastActivity: 'Última atividade',
    screenshot: 'Captura de ecrã',
    privilegeEscalation: 'Escalada de privilégios',
    downloadLogs: 'Descarregar logs',
    migrationRecommended: 'Migração recomendada',
    connected: 'Ligado',
    connecting: 'A ligar...',
    confirmInstallPersistence: 'Instalar um mecanismo de persistência?',
    confirmCloseSession: 'Tem a certeza de que quer fechar esta sessão?'
  },

  // Attack
  attack: {
    title: 'Centro de Ataque',
    description: 'Ferramentas de ataque avançadas e orquestrador dinâmico',
    selectTarget: 'Selecionar alvo',
    selectTechnique: 'Selecionar técnica',
    launchAttack: 'Lançar ataque',
    attackInProgress: 'Ataque em progresso',
    attackCompleted: 'Ataque concluído',
    attackFailed: 'Ataque falhado',
    techniques: 'Técnicas',
    payloads: 'Payloads',
    results: 'Resultados',
    dynamicOrchestrator: 'Orquestrador Dinâmico',
    attackGraph: 'Grafo de Ataque',
    attackBuilder: 'Construtor de Ataque',
    launchChain: 'Lançar cadeia',
    continueChain: 'Retomar',
    restartAll: 'Relançar tudo',
    executing: 'A executar...',
    aiSuggestions: 'Sugestões IA',
    ready: 'Pronto',
    inProgress: 'Em progresso...'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Ferramentas de ataque AD com assistência IA LLM e PoC automatizado',
    domain: 'Domínio',
    dcIp: 'IP do Controlador de Domínio',
    username: 'Nome de utilizador',
    password: 'Palavra-passe',
    ntlmHash: 'Hash NTLM (opcional)',
    dcConfiguration: 'Configuração do Controlador de Domínio',
    attacks: 'Ataques AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Pesquisar um ataque, uma ferramenta...',
    allCategories: 'Todas as categorias',
    attackCategories: 'Categorias de Ataques',
    targetResults: 'Alvo / Resultados',
    noDataMessage: 'Selecione um ataque para começar',
    noDataHint: 'Ou use Auto PoC para uma cadeia de ataques',
    readyToStart: 'Pronto para começar',
    stats: {
      attacks: 'Ataques',
      successful: 'Bem-sucedidos',
      failed: 'Falhados',
      credentials: 'Credenciais',
      users: 'Utilizadores',
      paths: 'Caminhos'
    },
    attackWizard: 'Assistente de Ataques AD',
    backToAD: 'Voltar à página AD',
    auditRunning: 'Auditoria AD em curso',
    auditRunningDesc: 'A analisar o Active Directory {domain}... A página é atualizada automaticamente.',
    auditFailed: 'Auditoria falhada',
    globalRiskScore: 'Pontuação de risco global',
    scoresByCategory: 'Pontuações por categoria',
    noScoresCalculated: 'Nenhuma pontuação calculada',
    auditInfo: 'Informações da auditoria',
    criticalIndicatorsPriority: 'Indicadores críticos a tratar com prioridade',
    riskScoreCritical: 'O domínio apresenta vulnerabilidades críticas que requerem ação imediata.',
    riskScoreHigh: 'Foram identificados riscos significativos no domínio Active Directory.',
    riskScoreMedium: 'Alguns aspetos a melhorar com prioridade média.',
    riskScoreLow: 'O domínio apresenta um nível de risco baixo. Mantenha as boas práticas.',
    objectsAffected: '{count} objeto(s) afetado(s)',
    recommendedSolution: 'Solução recomendada',
    noActionRequired: 'Nenhuma ação necessária',
    noRiskIndicators: 'O domínio não apresenta nenhum indicador de risco.',
    immediateActions: 'Ações imediatas',
    recommendedImprovements: 'Melhorias recomendadas',
    prioritizedActionPlan: 'Plano de ação priorizado com base em {count} indicadores detetados. As ações imediatas (< 30d) devem ser tratadas antes da geração de relatórios AD.',
    generateAIAnalysis: 'Gerar a análise IA',
    generateAIAnalysisDesc: 'A IA irá analisar os {count} indicadores AD para:',
    generatingAI: 'Análise em curso…',
    generatingAIDesc: 'A IA analisa os {count} indicador(es) AD e gera o guia de ataque',
    generatingAITime: 'Isto pode demorar 2 a 4 minutos consoante a carga do servidor GPU',
    analysisGenerated: 'Análise gerada — {domain} · Pontuação {score}/100 ({risk})',
    indicatorsAnalyzed: '{count} indicador(es) analisado(s)',
    regenerate: 'Regenerar',
    rawResponse: 'Resposta bruta',
    analysisError: 'Nota: A análise utilizou um fallback (serviço IA não disponível).',
    downloadEvidenceReport: 'Transferir o relatório de evidências (.txt)',
    noIndicatorsForFilter: 'Nenhum indicador de severidade {filter}.',
    noRiskIndicatorsDetected: 'Nenhum indicador de risco detetado.',
    statsDomainAdmins: 'Admins de domínio',
    statsMaxPrivAccounts: 'Contas com máximo privilégio',
    statsKerberoastable: 'Kerberoastable',
    statsInventory: 'Inventário',
    statsPrivilegedGroups: 'Grupos com privilégios',
    statsKerberosDeleg: 'Kerberos e Delegação',
    statsOtherAnomalies: 'Outras anomalias',
    statsInterpretation: 'Interpretação de estatísticas',
    lapsDeployed: 'Implementado',
    lapsAbsent: 'Ausente',
    highIndicators: 'Indicadores High',
    statusDone: '✓ Concluído',
    statusRunning: '⟳ Em curso',
    statusFailed: '✗ Falhado',
    scanIdLabel: 'ID da varredura',
    startedLabel: 'Iniciado',
    completedLabel: 'Concluído',
    sessionStatusCompleted: 'Concluído',
    sessionStatusFailed: 'Falhado',
    sessionStatusStopped: 'Parado',
    sessionStatusInitialized: 'Inicializado',
    sessionTabOverview: 'Visão geral',
    sessionTabSteps: 'Passos',
    sessionTabFindings: 'Findings',
    sessionTabTimeline: 'Cronologia',
    sessionTabAI: 'Análise IA',
    sessionFindingsDetected: 'Findings detetados',
    sessionStepsExecuted: 'Passos executados',
    sessionStepsFailed: '{count} falhados, {skipped} ignorados',
    sessionCredentialsFound: 'Credenciais encontradas',
    sessionCompromisedAccounts: 'Contas comprometidas',
    sessionUsersEnumerated: 'Utilizadores enumerados',
    sessionDuration: 'Duração: {duration}',
    sessionDomainCompromised: 'Domínio comprometido',
    sessionDomainCompromisedDesc: 'As técnicas executadas demonstraram o comprometimento do domínio Active Directory {domain}. Ação imediata necessária.',
    sessionAttackPathsFound: 'Caminhos de ataque identificados',
    sessionAttackPathsDesc: 'Foram identificados vetores de escalada de privilégios ou movimento lateral no domínio.',
    sessionCriticalHighFindings: 'Findings críticos / altos',
    sessionStepsCompleted: 'Concluídos',
    sessionStepsSkipped: 'Ignorados',
    sessionNoMatchingSteps: 'Nenhum passo correspondente',
    sessionNoFindingsDetected: 'Nenhum finding detetado',
    sessionNoFindingsForFilter: 'Nenhum finding neste nível de severidade.',
    sessionNoTimelineEvents: 'Nenhum evento de cronologia',
    sessionStepsLabel: '{count} passos',
    sessionStepFindings: 'Findings do passo',
    sessionRecommendedRemediation: 'Remediação recomendada',
    sessionAICompromiseGuide: 'Análise IA — Guia de comprometimento AD',
    sessionAIWillAnalyze: 'A IA irá analisar todos os findings e passos desta sessão para:',
    sessionAIExplainDiscoveries: 'Explicar as descobertas',
    sessionAIIdentifyPaths: 'Identificar os caminhos de ataque',
    sessionAIStepByStep: 'Guia de comprometimento AD passo a passo',
    sessionAIPriorityRecs: 'Recomendações de remediação prioritárias',
    sessionAILoading: 'Geração automática do guia de comprometimento AD',
    sessionAILoadingTime: 'Isto pode demorar 2-4 minutos — processamento em segundo plano',
    sessionAIAnalysisFor: 'Análise gerada para {domain}',
    sessionAIAnalysisMeta: '{steps} passos · {findings} findings analisados',
    sessionAIAnalysisCredentials: '· {count} credenciais',
    sessionDownloadEvidence: 'Transferir todas as evidências (.txt)',
    sessionOutputLabel: 'Output',
    sessionStepFindingsLabel: 'Step findings',
    sessionAIAnalysisGenerationTime: 'Geração via Ollama (sylink/sylink2:27b) — aproximadamente 2-4 minutos',
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Plataforma de',
    platformSubtitle: 'Pentest Autônomo',
    platformDescription: 'Análise de segurança com IA, exploração automatizada e relatórios detalhados.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autônoma',
      description: 'Inteligência artificial que simula um pentester especialista',
      highlight: 'SYLink LLM On-Premise'
    },
    advancedDetection: {
      title: 'Detecção Avançada',
      description: 'Identificação automática de vulnerabilidades críticas',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Testes Completos',
      description: 'Varreduras de rede, web, API e infraestrutura',
      highlight: '100+ Ferramentas'
    },
    instantReports: {
      title: 'Relatórios Instantâneos',
      description: 'Geração automática de relatórios PDF profissionais',
      highlight: 'Exportar PDF'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilidade',
    vulnerabilities: 'Vulnerabilidades detectadas',
    monitoring: 'Monitoramento',
    scanTime: 'Tempo médio de varredura'
  },

  // Footer
  footer: {
    title: 'Plataforma de Scanner de Segurança',
    subtitle: 'Sistema Autônomo de Testes de Penetração',
    terms: 'Termos de Uso',
    sales: 'Termos de Venda',
    privacy: 'Política de Privacidade',
    legalNotice: 'Aviso Legal',
    contact: 'Contato',
    version: 'Versão',
    licence: 'Licença n°',
    poweredBy: 'Desenvolvido por SYLink IA',
    termsShort: 'Termos de Utilização (CGU)',
    salesShort: 'Termos de Venda (CGV)'
  },

  // Enrichment (ABSpider Integration)
  enrichment: {
    title: 'Enriquecimento de Dados',
    subtitle: 'Análise avançada de alvos com inteligência de segurança',
    description: 'Enriqueça seus dados de reconhecimento com múltiplas fontes de inteligência',

    // Scan Types
    scanTypes: {
      headers: 'Cabeçalhos de Segurança',
      security_headers: 'Cabeçalhos de Segurança',
      headersDesc: 'Analisa cabeçalhos HTTP de segurança e configuração do servidor',
      email_security: 'Segurança de Email',
      email_securityDesc: 'Verifica registros SPF, DKIM, DMARC e configuração de email',
      geoip: 'Geolocalização IP',
      geoipDesc: 'Localiza geograficamente endereços IP com informações detalhadas',
      reverse_ip: 'IP Reverso',
      reverse_ipDesc: 'Encontra todos os domínios hospedados em um endereço IP',
      virustotal: 'VirusTotal',
      virustotalDesc: 'Analisa URL/domínio com mais de 70 motores antivírus',
      full: 'Análise Completa',
      fullDesc: 'Executa todos os tipos de análise para uma visão abrangente'
    },

    // Status
    status: {
      pending: 'Pendente',
      running: 'Em Execução',
      completed: 'Concluído',
      failed: 'Falhou',
      partial: 'Parcial'
    },

    // Threat Levels
    threatLevels: {
      critical: 'Crítico',
      high: 'Alto',
      medium: 'Médio',
      low: 'Baixo',
      info: 'Informativo',
      unknown: 'Desconhecido'
    },

    // Form
    form: {
      target: 'Alvo',
      targetPlaceholder: 'Insira domínio, IP ou URL',
      scanType: 'Tipo de Análise',
      selectScanType: 'Selecione um tipo de análise',
      workspace: 'Workspace',
      selectWorkspace: 'Selecione um workspace',
      startScan: 'Iniciar Análise',
      quickScan: 'Análise Rápida',
      fullScan: 'Análise Completa',
      credits: 'Créditos',
      creditsRequired: 'créditos necessários'
    },

    // Results
    results: {
      title: 'Resultados da Análise',
      noResults: 'Nenhum resultado ainda',
      scanId: 'ID da Análise',
      target: 'Alvo',
      type: 'Tipo',
      status: 'Status',
      createdAt: 'Criado em',
      completedAt: 'Concluído em',
      duration: 'Duração',
      viewDetails: 'Ver Detalhes',
      exportJson: 'Exportar JSON',
      exportCsv: 'Exportar CSV',
      refresh: 'Atualizar'
    },

    // Headers Analysis
    headers: {
      title: 'Análise de Cabeçalhos de Segurança',
      securityScore: 'Pontuação de Segurança',
      headersFound: 'Cabeçalhos Encontrados',
      headersMissing: 'Cabeçalhos Ausentes',
      serverInfo: 'Informações do Servidor',
      recommendations: 'Recomendações',
      headerName: 'Nome do Cabeçalho',
      headerValue: 'Valor',
      headerStatus: 'Status',
      present: 'Presente',
      missing: 'Ausente',
      contentSecurityPolicy: 'Content-Security-Policy',
      strictTransportSecurity: 'Strict-Transport-Security',
      xFrameOptions: 'X-Frame-Options',
      xContentTypeOptions: 'X-Content-Type-Options',
      xXssProtection: 'X-XSS-Protection',
      referrerPolicy: 'Referrer-Policy',
      permissionsPolicy: 'Permissions-Policy'
    },

    // Email Security
    email: {
      title: 'Análise de Segurança de Email',
      spf: 'Registro SPF',
      dkim: 'Registro DKIM',
      dmarc: 'Registro DMARC',
      mxRecords: 'Registros MX',
      valid: 'Válido',
      invalid: 'Inválido',
      notFound: 'Não Encontrado',
      policy: 'Política',
      record: 'Registro',
      spfMechanism: 'Mecanismo SPF',
      dmarcPolicy: 'Política DMARC',
      quarantine: 'Quarentena',
      reject: 'Rejeitar',
      none: 'Nenhum'
    },

    // GeoIP
    geoip: {
      title: 'Geolocalização IP',
      ip: 'Endereço IP',
      country: 'País',
      region: 'Região',
      city: 'Cidade',
      postalCode: 'CEP',
      latitude: 'Latitude',
      longitude: 'Longitude',
      timezone: 'Fuso Horário',
      isp: 'Provedor',
      organization: 'Organização',
      asn: 'ASN',
      asnName: 'Nome ASN',
      mapView: 'Visualização do Mapa',
      copyCoordinates: 'Copiar Coordenadas'
    },

    // Reverse IP
    reverseIp: {
      title: 'Pesquisa IP Reverso',
      domainsFound: 'Domínios Encontrados',
      totalDomains: 'Total de Domínios',
      domainName: 'Nome do Domínio',
      firstSeen: 'Primeira Detecção',
      lastSeen: 'Última Detecção',
      sharedHosting: 'Hospedagem Compartilhada Detectada',
      dedicatedHosting: 'Hospedagem Dedicada',
      potentialTargets: 'Alvos Potenciais'
    },

    // VirusTotal
    virustotal: {
      title: 'Análise VirusTotal',
      scanDate: 'Data da Análise',
      permalink: 'Link Permanente',
      positives: 'Detecções Positivas',
      total: 'Motores Totais',
      clean: 'Limpo',
      suspicious: 'Suspeito',
      malicious: 'Malicioso',
      undetected: 'Não Detectado',
      engineName: 'Nome do Motor',
      engineResult: 'Resultado',
      category: 'Categoria',
      detectionRatio: 'Taxa de Detecção',
      communityScore: 'Pontuação da Comunidade',
      lastAnalysis: 'Última Análise'
    },

    // Stats
    stats: {
      totalScans: 'Análises Totais',
      completedScans: 'Análises Concluídas',
      failedScans: 'Análises Falhadas',
      averageTime: 'Tempo Médio',
      creditsUsed: 'Créditos Utilizados',
      threatsFound: 'Ameaças Encontradas'
    },

    // Errors
    errors: {
      invalidTarget: 'Alvo inválido. Insira um domínio, IP ou URL válido.',
      scanFailed: 'A análise falhou. Por favor, tente novamente.',
      insufficientCredits: 'Créditos insuficientes para esta análise.',
      targetNotReachable: 'Alvo não alcançável. Verifique a conectividade.',
      rateLimited: 'Limite de taxa atingido. Por favor, aguarde antes de tentar novamente.',
      apiError: 'Erro de API. Por favor, tente novamente mais tarde.',
      timeout: 'A análise atingiu o tempo limite. O alvo pode estar lento ou indisponível.'
    },

    // Tooltips
    tooltips: {
      securityHeaders: 'Os cabeçalhos de segurança protegem contra ataques web comuns',
      emailSecurity: 'A autenticação de email previne spoofing e phishing',
      geoip: 'A localização geográfica pode revelar informações de hospedagem',
      reverseIp: 'O IP reverso mostra outros sites no mesmo servidor',
      virustotal: 'O VirusTotal agrega detecções de múltiplos motores antivírus',
      credits: 'Cada tipo de análise consome uma quantidade diferente de créditos',
      virusTotalCredit: 'Usa a API VirusTotal para analisar a reputação',
      headersCredit: 'Analisa os cabeçalhos HTTP de segurança',
      emailCredit: 'Verifica SPF, DKIM e DMARC',
      geoipCredit: 'Geolocaliza o endereço IP',
      reverseIpCredit: 'Encontra domínios alojados no mesmo IP',
      fullCredit: 'Realiza todas as análises',
    },
    target: 'Alvo',
    type: 'Tipo',
    modules: 'Módulos',
    quickScans: 'Análises rápidas',
    threatSummary: 'Resumo de ameaças',
    recentScans: 'Análises recentes',
    riskScore: 'Pontuação de risco',
    date: 'Data',
    noScans: 'Sem análises por agora',
    scan: 'Analisar',
    quickResult: 'Resultado da análise rápida',
    scanDetails: 'Detalhes da análise',
    statusLabel: 'Estado',
    newScan: 'Nova análise',
    quickScan: 'Análise rápida',
    fullScan: 'Análise completa',
    viewDetails: 'Ver detalhes',
    exportReport: 'Exportar relatório',
    refresh: 'Atualizar',
    recentIndicators: 'Indicadores recentes',
    aiAnalysis: {
      title: 'Análise IA',
      executiveSummary: 'Resumo executivo',
      keyFindings: 'Pontos-chave',
      recommendations: 'Recomendações',
    },
    error: {
      targetRequired: 'O alvo é obrigatório',
      scanFailed: 'Erro ao iniciar a análise',
      quickScanFailed: 'Erro na análise rápida',
      loadFailed: 'Erro ao carregar os detalhes da análise',
      deleteFailed: 'Erro ao eliminar a análise',
    },
    success: {
      scanStarted: 'Análise iniciada com sucesso',
      quickScanComplete: 'Análise rápida concluída',
      scanDeleted: 'Análise eliminada',
    },
    scanTypes: {
      domain: 'Domínio',
      ip: 'Endereço IP',
      url: 'URL',
      ai_scan: 'Análise IA',
      network_discovery: 'Descoberta de rede',
      vulnerability_scan: 'Análise de vulnerabilidades',
      full_autonomous: 'Autónomo completo',
      full_auto: 'Autónomo completo',
      full_automation: 'Autónomo completo',
      expert: 'Análise especializada',
      api_pentest: 'Pentest API',
      iot_scan: 'Análise IoT',
      ot_scan: 'Análise OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Análise Active Directory',
      ad_recon: 'Reconhecimento AD',
      ad_full: 'Análise AD completa',
      ldap_scan: 'Análise LDAP',
      kerberos_scan: 'Análise Kerberos',
      web_scan: 'Análise Web',
      web: 'Análise Web',
      quick: 'Rápida',
      quick_scan: 'Análise rápida',
      discovery: 'Descoberta',
      enumeration: 'Enumeração',
      vulnerability: 'Vulnerabilidades',
      exploitation: 'Exploração',
      passive: 'Passivo',
      aggressive: 'Agressivo',
      credentials: 'Credenciais',
      recon: 'Reconhecimento',
      exploit: 'Exploração',
      bypass: 'Bypass',
      nmap: 'Análise Nmap',
      nikto: 'Análise Nikto',
      internal: 'Análise interna',
      external: 'Análise externa',
      network: 'Análise de rede',
    },
    threatLevels: {
      safe: 'Seguro',
      low: 'Baixo',
      medium: 'Médio',
      high: 'Alto',
    },
    form: {
      targetDomain: 'Domínio alvo',
      targetDomainPlaceholder: 'ex: exemplo.com',
      targetIp: 'Endereço IP (opcional)',
      targetIpPlaceholder: 'ex: 192.168.1.1',
      startScan: 'Iniciar análise',
    },
    status: {
      queued: 'Na fila',
      cancelled: 'Cancelado',
    },
    stats: {
      pendingScans: 'Análises pendentes',
      averageScore: 'Pontuação média',
      criticalThreats: 'Ameaças críticas',
      highThreats: 'Ameaças altas',
    },
  },

  // Support
  support: {
    title: 'Suporte',
    myTickets: 'Meus Tickets de Suporte',
    newTicket: 'Novo ticket',
    createTicket: 'Criar um ticket',
    ticketDetails: 'Detalhes do ticket',
    ticketNumber: 'Ticket n°{number}',
    backToList: 'Voltar à lista',
    noTickets: 'Nenhum ticket de suporte',
    noTicketsDescription: 'Você ainda não criou nenhum ticket de suporte.',
    subject: 'Assunto',
    subjectPlaceholder: 'Descreva brevemente seu problema',
    description: 'Descrição',
    descriptionPlaceholder: 'Descreva seu problema em detalhes...',
    category: 'Categoria',
    priority: 'Prioridade',
    status: 'Status',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    lastResponse: 'Última resposta',
    messages: 'Mensagens',
    addResponse: 'Adicionar uma resposta',
    responsePlaceholder: 'Escreva sua resposta...',
    sendResponse: 'Enviar',
    closeTicket: 'Fechar ticket',
    reopenTicket: 'Reabrir ticket',
    attachments: 'Anexos',
    addAttachment: 'Adicionar um anexo',
    responseFromSupport: 'Resposta do suporte',
    yourResponse: 'Sua resposta',
    statuses: {
      open: 'Aberto',
      pending: 'Pendente',
      in_progress: 'Em andamento',
      waiting_customer: 'A aguardar resposta',
      waiting_support: 'Aguardando suporte',
      waiting_internal: 'Em processamento',
      resolved: 'Resolvido',
      closed: 'Fechado'
    },
    priorities: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
      urgent: 'Urgente',
      critical: 'Crítica',
      lowDesc: 'Não urgente, pode aguardar',
      mediumDesc: 'Importância normal',
      highDesc: 'Requer atenção rápida',
      urgentDesc: 'Impacto crítico na atividade',
      priority: 'Prioridade'
    },
    categories: {
      technical: 'Problema técnico',
      billing: 'Faturamento',
      account: 'Conta',
      feature_request: 'Solicitação de funcionalidade',
      bug_report: 'Relato de bug',
      security: 'Segurança',
      other: 'Outro',
      technicalDesc: 'Problemas técnicos, erros, falhas',
      billingDesc: 'Questões sobre faturas, pagamentos, subscrições',
      feature_requestDesc: 'Sugestões de melhoria ou novas funcionalidades',
      bug_reportDesc: 'Reportar um bug ou comportamento inesperado',
      accountDesc: 'Gestão de conta, acesso, permissões',
      securityDesc: 'Questões ou preocupações de segurança',
      otherDesc: 'Outro tipo de pedido'
    },
    filters: {
      all: 'Todos',
      open: 'Abertos',
      closed: 'Fechados',
      myTickets: 'Meus tickets'
    },
    sort: {
      newest: 'Mais recentes',
      oldest: 'Mais antigos',
      priority: 'Por prioridade',
      status: 'Por status'
    },
    notifications: {
      newResponse: 'Nova resposta no seu ticket',
      statusChanged: 'Status do ticket atualizado',
      ticketClosed: 'Ticket fechado'
    },
    help: {
      title: 'Precisa de ajuda?',
      description: 'Nossa equipe de suporte está disponível para ajudá-lo.',
      responseTime: 'Tempo médio de resposta: menos de 24 horas',
      documentation: 'Consulte a documentação',
      faq: 'Perguntas frequentes'
    },
    errors: {
      loadFailed: 'Erro ao carregar os tickets',
      loadingTickets: 'Erro ao carregar os tickets',
      loadingTicket: 'Erro ao carregar o ticket',
      createFailed: 'Erro ao criar o ticket',
      creatingTicket: 'Erro ao criar o ticket',
      updateFailed: 'Erro ao atualizar o ticket',
      responseFailed: 'Erro ao enviar a resposta',
      sendingMessage: 'Erro ao enviar a mensagem',
      closingTicket: 'Erro ao fechar o ticket',
      ticketNotFound: 'Ticket não encontrado',
      retry: 'Tentar novamente',
      fixFormErrors: 'Por favor corrija os erros no formulário',
      subjectRequired: 'O assunto é obrigatório',
      subjectMinLength: 'O assunto deve ter pelo menos 5 caracteres',
      descriptionRequired: 'A descrição é obrigatória',
      descriptionMinLength: 'A descrição deve ter pelo menos 20 caracteres',
      categoryRequired: 'Selecione uma categoria'
    },
    success: {
      ticketCreated: 'Ticket {number} criado com sucesso',
      responseSent: 'Resposta enviada com sucesso',
      messageSent: 'Mensagem enviada',
      ticketClosed: 'Ticket fechado com sucesso',
      ticketReopened: 'Ticket reaberto com sucesso'
    },
    // FR-style flat keys
    message: 'Mensagem',
    manageRequests: 'Gira as suas solicitações de assistência',
    created: 'Criado',
    createdOn: 'Criado em',
    updated: 'Última atualização',
    resolved: 'Resolvido',
    resolvedOn: 'Resolvido em',
    noTicketsFound: 'Nenhum ticket encontrado',
    noTicketsYet: 'Ainda não criou nenhum ticket de suporte',
    tryModifyingSearch: 'Tente modificar os seus critérios de pesquisa',
    createFirstTicket: 'Criar o meu primeiro ticket',
    sendMessage: 'Enviar uma mensagem',
    send: 'Enviar',
    sending: 'A enviar...',
    closing: 'A fechar...',
    ticketClosed: 'Este ticket está fechado. Para um novo pedido, crie um novo ticket.',
    search: 'Pesquisar um ticket...',
    allStatuses: 'Todos os estados',
    refresh: 'Atualizar',
    backToTickets: 'Voltar aos tickets',
    ticketNumberLabel: 'Número',
    you: 'Você',
    supportTeam: 'Suporte SYLink',
    system: 'Sistema',
    writeReply: 'Escreva a sua resposta...',
    detailedDescription: 'Descrição detalhada',
    informations: 'Informações',
    needHelp: 'Precisa de ajuda?',
    responseTime: 'Tempo de resposta estimado',
    responseTimeDesc: 'A nossa equipa responde geralmente em 24 horas úteis. Os tickets urgentes são tratados com prioridade. Receberá uma notificação por email assim que uma resposta for fornecida.',
    supportResponseDesc: 'A nossa equipa de suporte responde geralmente em 24 horas úteis. Para urgências, indique uma prioridade alta.',
    newTicketTitle: 'Novo Ticket',
    newTicketDesc: 'Descreva o seu problema e a nossa equipa responderá rapidamente',
    describeIssue: 'Descreva brevemente o seu problema...',
    relatedWorkspace: 'Cliente / Espaço de trabalho relacionado (opcional)',
    noSpecificWorkspace: 'Nenhum espaço de trabalho específico',
    detailedDescPlaceholder: 'Descreva o seu problema em detalhe. Quanto mais informação fornecer, mais rapidamente o poderemos ajudar...\n\n- O que está a tentar fazer?\n- O que está a acontecer?\n- O que esperava?\n- Tem alguma mensagem de erro?',
    charactersCount: '{count} caracteres',
    charactersMin: '{count} caracteres (mínimo {min})',
    cancel: 'Cancelar',
    creating: 'A criar...',
    rateSupport: 'Como avalia a qualidade do nosso suporte?',
    comment: 'Comentário (opcional)...',
    confirm: 'Confirmar',
    messagesPlural: 'mensagens',
    resolutionNotes: 'Notas de resolução',
    yourRating: 'A sua avaliação'
  },

  // Pricing
  pricing: {
    title: 'Escolha seu plano',
    subtitle: 'Soluções adaptadas a cada necessidade de segurança',
    monthly: 'Mensal',
    annually: 'Anual',
    save: 'Economize {percent}%',
    perMonth: '/mês',
    perYear: '/ano',
    currentPlan: 'Seu plano atual',
    selectPlan: 'Selecionar',
    contactUs: 'Contate-nos',
    popular: 'Popular',
    enterprise: 'Enterprise',
    plans: {
      gratuit: {
        name: 'Gratuito',
        subtitle: 'Descoberta',
        description: 'Ideal para testar a plataforma',
        cta: 'Começar gratuitamente',
        price: '0',
        features: [
          '1 varredura por mês',
          '1 workspace',
          'Relatório básico',
          'Suporte da comunidade'
        ]
      },
      pro: {
        name: 'Pro',
        subtitle: 'O mais popular',
        description: 'Para profissionais e PMEs',
        cta: 'Escolher Pro',
        badge: 'Recomendado',
        price: '99',
        features: [
          '50 varreduras por mês',
          '5 workspaces',
          'Relatórios avançados PDF',
          'Acesso à API',
          'Suporte prioritário'
        ]
      },
      entreprise: {
        name: 'Enterprise',
        subtitle: 'Para grandes equipas',
        description: 'Funcionalidades avançadas e suporte dedicado',
        cta: 'Escolher Enterprise',
        price: '299',
        features: [
          'Varreduras ilimitadas',
          'Workspaces ilimitados',
          'Relatórios white-label',
          'API completa',
          'SSO/SAML',
          'Gerente de conta dedicado'
        ]
      },
      entreprise_plus: {
        name: 'Grupo',
        subtitle: 'Para grandes organizações',
        description: 'Volume alargado e suporte premium',
        cta: 'Escolher Grupo'
      },
      groupe: {
        name: 'Grupo',
        subtitle: 'Para grandes organizações',
        description: 'Volume alargado e suporte premium',
        cta: 'Escolher Grupo',
        price: 'Personalizado',
        features: [
          'Todas as funcionalidades Enterprise',
          'Implantação on-premise',
          'Integrações personalizadas',
          'SLA garantido',
          'Treinamento incluído'
        ]
      },
      sur_mesure: {
        name: 'Por Medida',
        subtitle: 'Solução personalizada',
        description: 'Adaptada às suas necessidades específicas',
        cta: 'Contactar-nos'
      },
      dedicated: {
        name: 'Dedicado',
        description: 'Infraestrutura dedicada',
        price: 'Personalizado',
        features: [
          'Servidores dedicados',
          'Personalização completa',
          'Isolamento total de dados',
          'Auditoria de segurança',
          'Suporte 24/7'
        ]
      }
    },
    features: {
      scans: 'Varreduras',
      workspaces: 'Workspaces',
      reports: 'Relatórios',
      api: 'Acesso à API',
      support: 'Suporte',
      sso: 'SSO/SAML',
      whitelabel: 'White-label',
      onpremise: 'On-premise',
      unlimited: 'Ilimitado',
      simulationOnly: 'Apenas modo de simulação',
      oneUser: '1 utilizador',
      oneTarget: '1 alvo de teste',
      basicDashboard: 'Dashboard básico',
      realScans: 'Análises reais',
      pdfReports: 'Relatórios PDF',
      technicalSupport: 'Suporte técnico',
      apiAccess: 'Acesso à API',
      unlimitedScans: 'Análises IA ilimitadas',
      fiveUsers: '5 utilizadores',
      tenTargets: '10 alvos',
      customPdfReports: 'Relatórios PDF personalizados',
      credentialSearch: 'Pesquisa de credenciais',
      autoScheduling: 'Agendamento automático',
      prioritySupport: 'Suporte prioritário',
      allProFeatures: 'Tudo do plano Pro +',
      fifteenUsers: '15 utilizadores',
      thirtyTargets: '30 alvos',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Auditoria de conformidade',
      slaGuarantee: 'SLA garantido 99,9%',
      dedicatedSupport: 'Suporte dedicado',
      teamTraining: 'Formação de equipa incluída',
      allEnterpriseFeatures: 'Tudo do plano Enterprise +',
      unlimitedUsers: 'Utilizadores ilimitados',
      fiftyTargets: '50 alvos',
      advancedWorkspaces: 'Multi-espaços avançados',
      whiteLabelReports: 'Relatórios personalizáveis',
      support24_7: 'Suporte dedicado 24/7',
      accountManager: 'Gestor de conta dedicado',
      customOnboarding: 'Acompanhamento personalizado',
      allGroupeFeatures: 'Tudo do plano Grupo +',
      dedicatedInfra: 'Infraestrutura dedicada',
      customIntegrations: 'Integrações personalizadas',
      specificDevelopment: 'Desenvolvimentos específicos',
      sourceCodeAudit: 'Auditoria de código fonte',
      manualPentest: 'Testes de intrusão manuais',
      cissoSupport: 'Acompanhamento CISO',
      customContract: 'Contrato por medida'
    },
    faq: {
      title: 'Perguntas frequentes',
      questions: {
        q1: {
          question: 'Posso trocar de plano a qualquer momento?',
          answer: 'Sim, você pode fazer upgrade ou downgrade do seu plano a qualquer momento. A alteração será efetiva no próximo ciclo de faturamento.'
        },
        q2: {
          question: 'Existe um período de teste?',
          answer: 'Sim, oferecemos 14 dias de teste gratuito em todos os planos pagos para testar a plataforma.'
        },
        q3: {
          question: 'Quais métodos de pagamento são aceitos?',
          answer: 'Aceitamos cartões de crédito (Visa, Mastercard, Amex), transferências bancárias e PayPal.'
        },
        q4: {
          question: 'Os preços incluem impostos?',
          answer: 'Os preços exibidos são sem impostos. Os impostos serão adicionados de acordo com seu país.'
        }
      }
    },
    cta: {
      startTrial: 'Iniciar teste gratuito',
      getStarted: 'Começar',
      talkToSales: 'Fale com vendas',
      comparePlans: 'Comparar planos'
    },
    // Missing pricing keys
    yearly: 'Anual',
    yearlyDiscount: '-17%',
    perYear: '/ano',
    ht: 'S/ IVA',
    or: 'Ou seja',
    perMonthShort: '/mês',
    onQuote: 'Sob orçamento',
    free: 'Grátis',
    whyChoose: 'Porquê escolher SYLink Pentest?',
    aiTitle: 'Inteligência Artificial',
    aiDesc: 'A nossa IA analisa e explora vulnerabilidades de forma autónoma, simulando o comportamento de um pentester especialista.',
    securityTitle: 'Segurança Máxima',
    securityDesc: 'Os seus dados são encriptados e protegidos. Nenhuma informação sensível é armazenada após os testes.',
    reportsTitle: 'Relatórios Detalhados',
    reportsDesc: 'Gere relatórios PDF profissionais com recomendações de remediação e pontuação CVSS.',
    faqTitle: 'Perguntas frequentes',
    faqCanChangePlan: 'Posso mudar de plano?',
    faqCanChangePlanAnswer: 'Sim, pode fazer upgrade ou downgrade do seu plano a qualquer momento. As alterações são efetivas imediatamente e calculadas pro-rata.',
    faqFreePlan: 'Como funciona o plano gratuito?',
    faqFreePlanAnswer: 'O plano gratuito permite testar a plataforma em modo de simulação. Nenhuma análise real é efetuada, mas pode descobrir todas as funcionalidades.',
    faqCommitment: 'Existe algum compromisso?',
    faqCommitmentAnswer: 'Não, sem compromisso. Pode cancelar a qualquer momento. A faturação anual oferece 2 meses grátis.',
    faqSupport: 'Que suporte está incluído?',
    faqSupportAnswer: 'O plano Pro inclui suporte prioritário por email. O plano Enterprise beneficia de suporte dedicado 24/7.',
    needHelpChoosing: 'Precisa de ajuda para escolher?',
    needHelpDesc: 'A nossa equipa está disponível para o aconselhar e responder a todas as suas questões. Obtenha uma demonstração personalizada da plataforma.',
    needHelpDescShort: 'A nossa equipa está disponível para o acompanhar e responder a todas as suas questões.',
    requestCall: 'Solicitar chamada',
    welcomeTitle: 'Bem-vindo ao SYLink Pentest!',
    welcomeDesc: 'A sua conta está ativada. Escolha o plano que corresponde às suas necessidades.',
    welcomeDescShort: 'Escolha o plano que corresponde às suas necessidades',
    paymentError: 'Erro de pagamento',
    close: 'Fechar',
    redirecting: 'A redirecionar...',
    securedByStripe: 'Pagamento seguro por Stripe',
    detailedComparison: 'Comparação detalhada',
    infrastructureOptions: 'Opções de infraestrutura',
    infrastructureDesc: 'Escolha o modo de implementação adaptado às suas necessidades e restrições',
    choosePlan: 'Escolha o seu',
    choosePlanHighlight: 'plano',
    pageSubtitle: 'Automatize os seus testes de intrusão com IA. Do freelancer à empresa, temos o plano certo para si.',
    contactBanner: 'Todos os nossos planos são personalizados às suas necessidades',
    foreverFree: 'Para sempre',
    customPricing: 'Sob orçamento',
    customPricingLabel: 'Preço personalizado',
    perMonthHT: '/mês S/ IVA',
    billedPerYear: 'Faturado',
    billedPerYearSuffix: '/ano',
    requestQuote: 'Solicitar orçamento',
    startFree: 'Começar gratuitamente',
    learnMoreDedicated: 'Saiba mais sobre servidores dedicados',
    readOnlyApi: 'Apenas leitura',
    featureRow: 'Funcionalidade',
    priceRow: 'Preço'
  },

  // Notifications
  notifications: {
    title: 'Notificações',
    managementCenter: 'Centro de gestão de alertas e eventos',
    markAllRead: 'Marcar tudo como lido',
    clearAll: 'Limpar tudo',
    noNotifications: 'Nenhuma notificação',
    noNotificationsDescription: 'Você não tem nenhuma notificação no momento',
    viewAll: 'Ver todas as notificações',
    settings: 'Configurações de notificações',
    loadMore: 'Carregar mais',
    justNow: 'Agora mesmo',
    minutesAgo: '{count} minutos atrás',
    hoursAgo: '{count} horas atrás',
    daysAgo: '{count} dias atrás',
    scanRunning: 'Varredura em andamento',
    viewAll: 'Ver todas as notificações',
    scanCompleted: 'Varredura concluída',
    criticalVulnsFound: '{count} vulnerabilidade{count, plural, =1 {} other {s}} crítica{count, plural, =1 {} other {s}}',
    types: {
      scan_completed: 'Varredura concluída',
      scan_failed: 'Varredura falhou',
      vulnerability_found: 'Vulnerabilidade detectada',
      report_ready: 'Relatório pronto',
      subscription_expiring: 'Assinatura expirando',
      credits_low: 'Créditos baixos',
      new_feature: 'Nova funcionalidade',
      system: 'Sistema'
    },
    filters: {
      all: 'Todas',
      unread: 'Não lidas',
      read: 'Lidas',
      important: 'Importantes'
    },
    preferences: {
      title: 'Preferências de notificação',
      email: 'Notificações por email',
      push: 'Notificações push',
      inApp: 'Notificações no app',
      scanUpdates: 'Atualizações de varredura',
      securityAlerts: 'Alertas de segurança',
      productNews: 'Novidades do produto',
      weeklyReport: 'Relatório semanal'
    },
    status: {
      read: 'Lido',
      unread: 'Não lido'
    },
    // FR-style flat keys
    aiAssistant: 'Assistente IA',
    aiAssistantTitle: 'Assistente IA - Notificações',
    aiPlaceholder: 'Faça uma pergunta sobre as suas notificações...',
    soundEnabled: 'Sons ativados',
    criticalOnly: 'Apenas críticas',
    autoMarkRead: 'Marcar lido automaticamente',
    filters: 'Filtros',
    total: 'Total',
    unread: 'Não lidas',
    critical: 'Críticas',
    warning: 'Atenção',
    success: 'Sucesso',
    info: 'Informação',
    allRead: 'Todas as notificações foram lidas',
    noNotificationsDesc: 'Não tem nenhuma notificação de momento',
    noNotificationsType: 'Nenhuma notificação do tipo "{type}"',
    typeCritical: 'Crítica',
    typeWarning: 'Atenção',
    typeSuccess: 'Sucesso',
    typeInfo: 'Info',
    vulnsDetected: '{count} vulnerabilidade{count, plural, =1 {} other {s}} detetada{count, plural, =1 {} other {s}}',
    hostsScanned: '{count} hosts analisados em {target}',
    scanCompletedNoVulns: 'Análise concluída - Nenhuma vulnerabilidade',
    noVulnsDetected: 'Nenhuma vulnerabilidade detetada em {target}',
    scanInProgress: 'Análise em curso',
    analyzing: 'A analisar {target}...',
    scanFailed: 'Análise falhada',
    errorOn: 'Erro em {target}'
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Scanner Antivírus',
    subtitle: 'Analisar arquivos contra malware usando ClamAV',
    adminTitle: 'Gestão Antivírus',
    adminSubtitle: 'Monitorar ClamAV e gerir quarentena',
    scannerTab: 'Scanner de Arquivos',
    adminTab: 'Administração',

    // File Upload
    dropzone: 'Arraste um arquivo aqui ou clique para fazer upload',
    dropzoneActive: 'Solte o arquivo aqui...',
    scanning: 'A analisar...',
    uploadAndScan: 'Carregar e Analisar',
    maxFileSize: 'Tamanho máximo do arquivo: {size}',

    // Scan Results
    scanResult: 'Resultado da análise',
    clean: 'Limpo',
    infected: 'Infectado',
    error: 'Erro',
    pending: 'Pendente',
    threatDetected: 'Ameaça detectada',
    noThreatsFound: 'Nenhuma ameaça encontrada',
    threatName: 'Nome da ameaça',
    scanTime: 'Tempo de análise',
    fileHash: 'Hash do arquivo',

    // History
    scanHistory: 'Histórico de análises',
    noScansYet: 'Sem análises ainda',
    noScansYetDesc: 'Carregue um arquivo para começar a analisar',

    // Admin Dashboard
    clamavStatus: 'Estado do ClamAV',
    version: 'Versão',
    signatureCount: 'Número de assinaturas',
    lastUpdate: 'Última atualização',
    databaseStatus: 'Estado da base de dados',
    upToDate: 'Atualizado',
    outdated: 'Desatualizado',

    // Statistics
    statistics: 'Estatísticas',
    totalScans: 'Total de análises',
    cleanFiles: 'Arquivos limpos',
    infectedFiles: 'Arquivos infectados',
    errorScans: 'Análises com erro',

    // Quarantine
    quarantine: 'Quarentena',
    quarantineEmpty: 'Quarentena vazia',
    quarantineEmptyDesc: 'Nenhum arquivo em quarentena',
    deleteFromQuarantine: 'Eliminar da quarentena',
    cleanupQuarantine: 'Limpar quarentena',

    // Errors
    uploadError: 'Erro ao carregar o arquivo',
    scanError: 'Erro ao analisar o arquivo',
    fileTooLarge: 'O arquivo é demasiado grande',
    invalidFileType: 'Tipo de arquivo inválido',
    serviceUnavailable: 'Serviço antivírus indisponível',
    scanFile: 'Analisar um arquivo',
    scanNow: 'Analisar agora',
    scanAll: 'Analisar todos os arquivos',
    dropOrClick: 'Soltar um arquivo ou clicar para selecionar',
    dropFiles: 'Soltar os arquivos aqui ou clicar para selecionar',
    maxSize: 'Tamanho máximo por arquivo',
    selectedFiles: 'Arquivos selecionados',
    recentScans: 'Análises recentes',
    summary: 'Resumo da análise',
    unavailable: 'ClamAV indisponível',
    dataScanned: 'Dados analisados',
    threatsBySeverity: 'Ameaças por gravidade',
    performance: 'Desempenho',
    avgScanTime: 'Tempo médio de análise',
    cacheEntries: 'Entradas em cache',
    filename: 'Nome do arquivo',
    size: 'Tamanho',
    status: 'Estado',
    threat: 'Ameaça',
    severity: 'Gravidade',
    scannedAt: 'Analisado',
    daemonStatus: 'Estado do daemon',
    signatureVersion: 'Versão das assinaturas',
    reloadSignatures: 'Recarregar assinaturas',
    noQuarantine: 'Nenhum arquivo em quarentena',
    quarantinedAt: 'Colocado em quarentena',
    expiresAt: 'Expira',
    cleanupExpired: 'Limpar expirados',
    confirmDelete: 'Tem a certeza de que quer eliminar permanentemente este arquivo?',
    typeNotAllowed: 'Tipo de arquivo não permitido',
    total: 'Total'
  },

  // Contracts
  contracts: {
    title: 'Contratos',
    contract: 'Contrato',
    newContract: 'Novo contrato',
    createContract: 'Criar contrato',
    editContract: 'Editar contrato',
    contractNumber: 'Número do contrato',
    contractTitle: 'Título',
    statusLabel: 'Estado',

    // Status
    status: {
      draft: 'Rascunho',
      pending_signature: 'Aguardando assinatura',
      signed: 'Assinado',
      active: 'Ativo',
      completed: 'Concluído',
      expired: 'Expirado',
      cancelled: 'Cancelado'
    },

    // Provider
    provider: 'Prestador',
    providerInfo: 'Informações do prestador',
    providerName: 'Nome da empresa',
    providerSiret: 'SIRET',
    providerAddress: 'Endereço',

    // Client
    client: 'Cliente',
    clientInfo: 'Informações do cliente',
    clientName: 'Nome da empresa',
    clientRepresentative: 'Representante do cliente',
    clientContact: 'Contacto',

    // Perimeter
    perimeter: 'Perímetro',
    perimeterDescription: 'Intervalos de IP e alvos a testar',
    addPerimeterItem: 'Adicionar item ao perímetro',

    // Period
    interventionPeriod: 'Período de intervenção',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    riskPeriod: 'Período de risco (dias)',

    // Signature
    signature: {
      title: 'Assinatura eletrónica',
      sign: 'Assinar',
      signed: 'Assinado',
      pendingSignature: 'Aguardando assinatura',
      signContract: 'Assinar contrato',
      signatureType: 'Tipo de assinatura',
      typed: 'Digitada',
      drawn: 'Desenhada',
      uploaded: 'Carregada',

      // Signatory
      signatory: 'Signatário',
      signatoryInfo: 'Identidade do signatário',
      signatoryFirstName: 'Nome',
      signatoryLastName: 'Apelido',
      signatoryEmail: 'Email',
      signatoryFullName: 'Nome completo',

      // Legal
      legalMention: 'Menção legal',
      legalAcceptance: 'Aceito os termos do contrato',
      acceptTerms: 'Confirmo ter lido e aceite este contrato de pentest',

      // Verification
      verification: 'Verificação',
      verificationMethod: 'Método de verificação',
      smsVerification: 'Verificação por SMS',
      smsCode: 'Código SMS',
      sendCode: 'Enviar código',
      verifyCode: 'Verificar código',
      codeExpired: 'Código expirado',
      invalidCode: 'Código inválido',
      codeSent: 'Código enviado para o seu telefone',

      // Metadata (DocuSign-style)
      metadata: 'Metadados da assinatura',
      signedBy: 'Assinado por',
      signedAt: 'Assinado em',
      signedAtTime: 'Hora da assinatura',
      ipAddress: 'Endereço IP',
      userAgent: 'Navegador / Dispositivo',
      geolocation: 'Localização',

      // Certificate
      certificate: 'Certificado de assinatura',
      certificateOfCompletion: 'Certificado de conclusão',
      signatureCertificate: 'Certificado de assinatura',
      downloadCertificate: 'Descarregar certificado',
      viewCertificate: 'Ver certificado',

      // Integrity
      integrity: 'Integridade do documento',
      documentHash: 'Hash do documento (SHA-512)',
      signatureHash: 'Hash da assinatura (SHA-512)',
      hashVerified: 'Hash verificado',
      hashMismatch: 'Erro de hash',

      // Timeline / Audit
      timeline: 'Cronologia',
      auditTrail: 'Registo de auditoria',
      eventLog: 'Registo de eventos',
      created: 'Criado',
      sent: 'Enviado',
      viewed: 'Visualizado',
      signatureStarted: 'Assinatura iniciada',
      signatureCompleted: 'Assinatura concluída',

      // Success
      success: 'Contrato assinado com sucesso!',
      successMessage: 'O contrato foi assinado e está agora ativo.',
      thankYou: 'Obrigado pela sua assinatura',

      // Errors
      error: 'Erro de assinatura',
      errorMessage: 'Não foi possível assinar o contrato',
      expired: 'Link de assinatura expirado',
      alreadySigned: 'Contrato já assinado',
      invalidToken: 'Link de assinatura inválido',
      signatoryName: 'Nome do signatário',
      signatureDate: 'Data e hora da assinatura',
      acceptPentest: 'Válido para aceitação de Pentest',
      smsVerified: 'Validado',
      smsPending: 'Pendente',
      documentHash: 'Hash do documento',
      signatureHash: 'Hash da assinatura',
      hashAlgorithm: 'Algoritmo',
      sha512: 'SHA-512',
      createdAt: 'Criado em',
      sentAt: 'Enviado em',
      viewedAt: 'Consultado em',
      signedAt: 'Assinado em',
      viewCount: 'Número de consultas',
      action: 'Ação',
      timestamp: 'Timestamp',
      smsRequested: 'Código SMS solicitado',
      smsVerifiedAction: 'Código SMS verificado',
      signedAction: 'Assinatura efetuada',
      downloaded: 'Download',
      certificateType: 'CERTIFICADO DE ASSINATURA',
      platform: 'Plataforma',
      eidas: 'Assinatura eletrónica em conformidade com o regulamento eIDAS (UE) 910/2014',
      generatedAt: 'Certificado gerado em',
      downloadProof: 'Descarregar prova de assinatura',
      resendEmail: 'Reenviar por email',
      contractSigned: 'Contrato assinado com sucesso!',
      copySentByEmail: 'Uma cópia deste certificado será enviada por email.',
      enterSmsCode: 'Introduza o código SMS',
      smsCodeSent: 'Código SMS enviado',
      tooManyAttempts: 'Demasiadas tentativas'
    },

    // Actions
    send: 'Enviar para assinatura',
    resend: 'Reenviar',
    cancel: 'Cancelar contrato',
    download: 'Descarregar PDF',
    downloadSigned: 'Descarregar PDF assinado',
    preview: 'Pré-visualizar',

    // Notifications
    sentSuccess: 'Contrato enviado para assinatura',
    signedSuccess: 'Contrato assinado com sucesso',
    cancelledSuccess: 'Contrato cancelado',
    // Missing keys from FR contracts section
    draft: 'Rascunho',
    pendingSignature: 'Aguarda assinatura',
    signed: 'Assinado',
    active: 'Ativo',
    completed: 'Concluído',
    expired: 'Expirado',
    cancelled: 'Cancelado'
  },

  // VPN Configuration
  vpn: {
    title: 'Configuração VPN',
    configurations: 'Configurações VPN',
    noConfigurations: 'Sem configurações VPN',
    uploadConfig: 'Carregar configuração',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    connecting: 'Conectando...',
    disconnecting: 'Desconectando...',
    connect: 'Conectar',
    disconnect: 'Desconectar',
    status: 'Estado VPN',
    protocol: 'Protocolo',
    interface: 'Interface',
    publicIp: 'IP Público',
    vpnIp: 'IP VPN',
    country: 'País',
    city: 'Cidade',
    connectedSince: 'Conectado desde',
    routes: {
      title: 'Rotas de Rede',
      description: 'Gerir rotas de rede personalizadas para VPN',
      addRoute: 'Adicionar rota',
      destination: 'Destino CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Gateway',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Descrição',
      routeDescriptionPlaceholder: 'Rede interna do cliente',
      noRoutes: 'Sem rotas configuradas',
      deleteRoute: 'Eliminar rota',
      applyRoutes: 'Aplicar rotas',
      routeAdded: 'Rota adicionada com sucesso',
      routeDeleted: 'Rota eliminada',
      routesApplied: 'Rotas aplicadas',
      invalidCidr: 'Formato CIDR inválido',
      invalidGateway: 'Endereço IP inválido',
      active: 'Ativa',
      inactive: 'Inativa'
    },
    topology: {
      title: 'Topologia de Rede',
      server: 'Servidor Sylink',
      internet: 'Internet',
      vpnGateway: 'Gateway VPN',
      clientNetwork: 'Rede do Cliente',
      online: 'Online',
      offline: 'Offline',
      activeRoutes: 'Rotas ativas',
      totalRoutes: 'Rotas totais',
      networkGateway: 'Gateway de Rede',
      subnetsCount: '{{count}} sub-redes'
    },
    messages: {
      configUploaded: 'Configuração VPN carregada',
      configDeleted: 'Configuração VPN eliminada',
      connectionSuccess: 'VPN conectado com sucesso',
      connectionFailed: 'Erro de conexão VPN',
      disconnectionSuccess: 'VPN desconectado',
      disconnectionFailed: 'Erro de desconexão VPN',
      saveError: 'Erro ao guardar',
      deleteError: 'Erro ao eliminar',
      connectError: 'Erro de ligação VPN',
      disconnectError: 'Erro de desligação VPN'
    },
    server: 'Servidor',
    saveCredentials: 'Guardar credenciais para este VPN',
    loadingWorkspaces: 'A carregar workspaces...',
    noWorkspace: 'Nenhum workspace',
    noWorkspaceAvailable: 'Nenhum workspace disponível',
    noVpnFoundFor: 'Nenhum VPN encontrado para "{query}"',
    deleteStoredCredentialsTitle: 'Eliminar credenciais guardadas',
    saveCredentialsSecurely: 'Guardar credenciais de forma segura',
    saveCredentialsNow: 'Guardar agora',
    noVpnAvailable: 'Nenhuma configuração VPN disponível',
    loadingConfigs: 'A carregar configurações VPN...'
  },

  // Severity levels
  severity: {
    critical: 'Crítico',
    high: 'Alto',
    medium: 'Médio',
    low: 'Baixo',
    info: 'Info'
  },

  // APT Modules
  apt: {
    dangerousModule: 'Módulo perigoso - Usar com cautela',
    addToChain: 'Adicionar a uma cadeia',
    createChain: 'Criar cadeia de ataque',
    createChainButton: 'Criar cadeia',
    chainName: 'Nome da cadeia',
    selectedModules: 'Módulos selecionados',
    addModulesFromList: 'Adicione módulos da lista à direita',
    availableModules: 'Módulos disponíveis',
    newChain: 'Nova cadeia',
    executeModule: 'Executar {name}',
    loadError: 'Erro ao carregar dados APT',
    requiredParams: 'Parâmetros obrigatórios',
    executions: 'Execuções',
    successful: 'bem-sucedidas',
    avgTime: 'Tempo médio',
    modulesApt: 'Módulos APT',
    chains: 'Cadeias',
    evidence: 'Evidências',
    mitreMatrix: 'Matriz MITRE ATT&CK',
    category: 'Categoria',
    criticality: 'Criticidade',
    mitreTactic: 'Tática MITRE',
    allCategories: 'Todas',
    allCriticalities: 'Todas',
    allTactics: 'Todas',
    low: 'Baixo',
    medium: 'Médio',
    high: 'Alto',
    critical: 'Crítico',
    noModulesAvailable: 'Nenhuma campanha APT disponível no momento',
    noModulesFiltered: 'Nenhum módulo corresponde aos filtros selecionados',
    noChains: 'Nenhuma cadeia de ataque criada. Crie uma para começar.',
    noEvidence: 'Nenhuma evidência coletada. Execute módulos para coletar evidências.',
    chainStatus: 'Status',
    chainProgress: 'Progresso',
    chainModules: 'Módulos',
    chainCreatedAt: 'Criado em',
    executeChain: 'Executar {name}',
    moduleLaunched: 'Módulo {name} iniciado',
    moduleLaunchError: 'Erro ao iniciar o módulo',
    chainCreated: 'Cadeia criada com sucesso',
    chainCreateError: 'Erro ao criar a cadeia',
    chainLaunched: 'Cadeia iniciada',
    chainLaunchError: 'Erro ao iniciar a cadeia',
    chainPaused: 'Cadeia pausada',
    chainCancelled: 'Cadeia cancelada',
    dangerWarning: 'Este módulo está marcado como perigoso. Use com cautela.',
    modulesAvailable: 'módulos disponíveis',
    target: 'Alvo',
    duration: 'Duração',
    result: 'Resultado',
    title: 'Título',
    classification: 'Classificação',
    size: 'Tamanho',
    validated: 'Validado',
    searchPlaceholder: 'Pesquisar...',
    tool: 'Ferramenta',
    module: 'Módulo',
    exitCode: 'Código de saída',
    status: {
      pending: 'Pendente',
      queued: 'Em fila',
      running: 'Em andamento',
      paused: 'Pausado',
      completed: 'Concluído',
      failed: 'Falhou',
      cancelled: 'Cancelado',
      draft: 'Rascunho',
      ready: 'Pronto'
    },
    categories: {
      reconnaissance: 'Reconhecimento',
      resource_development: 'Desenvolvimento de recursos',
      initial_access: 'Acesso inicial',
      execution: 'Execução',
      persistence: 'Persistência',
      privilege_escalation: 'Escalada de privilégios',
      defense_evasion: 'Evasão de defesa',
      credential_access: 'Acesso a credenciais',
      discovery: 'Descoberta',
      lateral_movement: 'Movimento lateral',
      collection: 'Coleta',
      command_and_control: 'Comando e controle',
      exfiltration: 'Exfiltração',
      impact: 'Impacto'
    },
    criticalities: {
      low: 'Baixo',
      medium: 'Médio',
      high: 'Alto',
      critical: 'Crítico'
    }
  },

  // Equipment
  equipment: {
    title: 'Gestão de equipamentos',
    subtitle: 'Detecte, categorize e ataque os equipamentos da rede',
    totalEquipment: 'Total de equipamentos',
    totalEquipmentDesc: 'Número total de equipamentos registrados no banco de dados.',
    equipmentLabel: 'equipamentos',
    totalAttacks: 'Total de ataques',
    attacksLabel: 'ataques',
    successfulAttacks: 'Ataques bem-sucedidos',
    successfulAttacksLabel: 'bem-sucedidos',
    ongoingAttacks: 'Ataques em andamento',
    ongoingAttacksLabel: 'em andamento',
    typesTab: 'Tipos de equipamentos',
    detectedTab: 'Equipamentos detectados',
    attacksTab: 'Ataques',
    autoDetect: 'Auto-Detectar',
    refresh: 'Atualizar',
    searchPlaceholder: 'Pesquisar…',
    category: 'Categoria',
    allCategories: 'Todas'
  },

  // Workspace selector
  workspace: {
    select: 'Selecione um espaço de trabalho',
    selectTitle: 'Seleção de espaço de trabalho',
    selectDescription: 'Escolha um espaço de trabalho para continuar',
    searchPlaceholder: 'Pesquisar um espaço de trabalho...',
    noWorkspaces: 'Nenhum espaço de trabalho disponível',
    noWorkspacesYet: 'Nenhum espaço de trabalho criado',
    noResults: 'Nenhum espaço de trabalho encontrado',
    createFirst: 'Crie seu primeiro espaço de trabalho',
    createNew: 'Criar um espaço de trabalho',
    manageAll: 'Gerenciar espaços de trabalho',
    continue: 'Continuar',
    switchError: 'Erro ao trocar de espaço de trabalho',
    switchSuccess: 'Espaço de trabalho alterado com sucesso',
    scan: 'varredura',
    scans: 'varreduras',
    createRequired: 'Espaço de trabalho obrigatório',
    createRequiredDescription: 'Você precisa criar um espaço de trabalho para acessar esta seção.',
    selectRequired: 'Seleção obrigatória',
    selectRequiredDescription: 'Selecione um espaço de trabalho para acessar esta seção. Você tem',
    workspaceAvailable: 'espaço de trabalho disponível.',
    workspacesAvailable: 'espaços de trabalho disponíveis.',
    selectWorkspace: 'Selecione um espaço de trabalho'
  },

  // Phishing Simulation
  phishing: {
    title: 'Simulação de Phishing',
    subtitle: 'Teste a conscientização de segurança dos funcionários com campanhas de phishing simuladas',
    campaignsTab: 'Campanhas',
    templatesTab: 'Modelos',
    targetsTab: 'Grupos alvo',
    analyticsTab: 'Estatísticas',
    settingsTab: 'Configurações',
    totalCampaigns: 'Total de campanhas',
    emailsSent: 'E-mails enviados',
    clickRate: 'Taxa de cliques',
    reportRate: 'Taxa de denúncia',
    recentCampaigns: 'Campanhas recentes',
    newCampaign: 'Nova campanha',
    campaignName: 'Nome da campanha',
    status: 'Status',
    sent: 'Enviados',
    opened: 'Abertos',
    clicked: 'Clicados',
    reported: 'Denunciados',
    actions: 'Ações',
    viewDetails: 'Ver detalhes',
    emailTemplates: 'Modelos de e-mail',
    createTemplate: 'Criar modelo',
    targetGroups: 'Grupos alvo',
    createGroup: 'Criar grupo',
    groupName: 'Nome do grupo',
    members: 'Membros',
    lastUsed: 'Último uso',
    edit: 'Editar',
    delete: 'Excluir',
    analyticsOverview: 'Visão geral das análises',
    clickRateTrend: 'Tendência da taxa de cliques',
    reportRateTrend: 'Tendência da taxa de denúncia',
    chartPlaceholder: 'O gráfico será exibido aqui',
    departmentComparison: 'Comparação por departamento',
    settings: 'Configurações de Phishing',
    smtpConfig: 'Configuração SMTP',
    smtpServer: 'Servidor SMTP',
    smtpPort: 'Porta SMTP',
    trackingSettings: 'Configurações de rastreamento',
    trackOpens: 'Rastrear aberturas de e-mail',
    trackClicks: 'Rastrear cliques em links',
    trackSubmissions: 'Rastrear envios de credenciais',
    saveSettings: 'Salvar configurações',
    reference: 'Referência',
    statusCompleted: 'Concluída',
    statusActive: 'Ativa',
    statusScheduled: 'Agendada',
    statusCancelled: 'Cancelada',
    statusDraft: 'Rascunho',
    categoryCredentialHarvest: 'Coleta de credenciais',
    categoryLinkClick: 'Clique em link',
    categoryAttachment: 'Anexo'
  },

  // Sankey Analysis
  sankey: {
    title: 'Diagrama de Fluxo de Segurança',
    clickForAiAnalysis: 'Clique em um elemento para análise IA',
    exploitable: 'Explorável',
    nonExploitable: 'Não explorável',
    columns: {
      workspaces: 'Espaços de trabalho',
      targets: 'Alvos',
      assets: 'Ativos',
      vulnerabilities: 'Vulnerabilidades',
      exploitability: 'Explorabilidade',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Espaços de trabalho',
      targets: 'Alvos',
      critical: 'Crítico',
      nonExploitable: 'Não exploit.'
    },
    severity: {
      critical: 'Críticos',
      high: 'Altos',
      medium: 'Médios',
      low: 'Baixos'
    },
    analysis: {
      model: 'Modelo',
      changeModel: 'Analisar com outro LLM',
      selectModel: 'Selecionar modelo LLM',
      regenerateWith: 'Regenerar análise com outro modelo',
      recommended: 'Recomendado',
      regenerate: 'Regenerar análise'
    },
    noScansAvailable: 'Nenhuma varredura disponível para visualização',
    scansLabel: 'varreduras',
    hostsLabel: 'hosts',
    portsLabel: 'portas',
    occurrences: 'ocorrência(s)',
    tooltip: {
      element: 'Elemento',
      scansHostsVulns: '{scans} varreduras • {hosts} hosts • {vulns} vulnerabilidades',
      ipHostsVulns: '{ip} • {hosts} hosts • {vulns} vulnerabilidades',
      vulnsCount: '{count} vulnerabilidades',
      clickForAi: 'Clique para análise IA'
    },
    stats: {
      workspaces: 'Espaços de trabalho',
      targets: 'Alvos',
      assets: 'Ativos',
      vulnerabilities: 'Vulnerabilidades',
      exploitable: 'Explorável'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'Orquestrador LLM',
    subtitle: 'Gerenciamento e supervisão de modelos com aceleração GPU',
    gpuStatus: 'Status GPU',
    vram: 'VRAM',
    utilization: 'Utilização',
    load: 'Carregar',
    loaded: 'Carregado',
    noTarget: 'Nenhum alvo',
    entries: 'entradas',
    vulnerabilities: 'vulnerabilidades',
    credentials: 'credenciais',
    poolStatus: 'Status do Pool GPU',
    servers: 'servidores',
    moreModels: 'a mais',
    orchestratorMetrics: 'Métricas do Orquestrador',
    totalRequests: 'Total de requisições',
    modelSwaps: 'Trocas de modelo',
    avgSwapTime: 'Tempo médio de troca',
    inferences: 'Inferências',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    refresh: 'Atualizar',
    availableModels: 'Modelos disponíveis',
    activeSessions: 'Sessões ativas',
    noActiveSessions: 'Nenhuma sessão ativa',
    noSessionsHint: 'As sessões LLM usam inteligência artificial para analisar vulnerabilidades automaticamente.',
    noSessionsAction: 'Iniciar uma sessão',
    readyStatus: 'Pronto para iniciar',
    howToStart: 'Inicie uma varredura para começar uma sessão LLM',
    waitingForScan: 'Aguardando uma varredura',
    quickActions: 'Ações rápidas',
    newSession: 'Nova sessão',
    requestCheckpoint: 'Solicitar um checkpoint',
    hashcatTasks: 'Tarefas Hashcat',
    loadStatusFailed: 'Erro ao carregar o status LLM',
    loadingModel: 'Carregando {{model}}...',
    swapFailed: 'Erro ao trocar de modelo',
    noModel: 'Nenhum',
    online: 'Online',
    offline: 'Offline',
    serviceUnavailable: 'Serviço LLM indisponível'
  },

  // Tool Categories
  toolCategories: {
    reconnaissance: 'Reconhecimento',
    web: 'Scanner Web',
    cms: 'Scanners CMS',
    vulnerabilities: 'Scanners de Vulnerabilidades',
    bruteforce: 'Força Bruta',
    ad: 'Active Directory',
    ldap: 'LDAP / LDAPS',
    services: 'Enumeração de Serviços',
    osint: 'Inteligência de fontes abertas (OSINT)',
    suites: 'Suítes de Segurança',
    ssl: 'SSL/TLS',
    ot: 'OT/ICS/SCADA',
    iot: 'Dispositivos IoT',
    pivoting: 'Pivoting e Tunelamento',
    privesc: 'Escalada de Privilégios',
    evasion: 'Evasão e Bypass',
    supply_chain: 'Segurança da Cadeia de Suprimentos',
    network_attack: 'Ataques de Rede',
    firewall: 'Box / Firewall / Roteador',
    vpn: 'Segurança VPN',
    cloud: 'Segurança Cloud',
    other: 'Outros'
  },

  // OSINT
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'Cabeçalhos de segurança',
      security_headers: 'Cabeçalhos de segurança',
      email_security: 'Segurança de e-mail',
      geoip: 'Geolocalização IP',
      reverse_ip: 'IP reverso',
      full: 'Varredura completa',
      domain: 'Domínio',
      ip: 'Endereço IP',
      url: 'URL',
      network_discovery: 'Descoberta de rede',
      vulnerability_scan: 'Varredura de vulnerabilidades',
      full_autonomous: 'Autônomo completo',
      full_auto: 'Autônomo completo',
      full_automation: 'Autônomo completo',
      expert: 'Varredura especializada',
      api_pentest: 'Pentest API',
      iot_scan: 'Varredura IoT',
      ot_scan: 'Varredura OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Varredura Active Directory',
      ad_recon: 'Reconhecimento AD',
      ad_full: 'Varredura AD completa',
      ldap_scan: 'Varredura LDAP',
      kerberos_scan: 'Varredura Kerberos',
      web_scan: 'Varredura Web',
      web: 'Varredura Web',
      quick: 'Rápida',
      quick_scan: 'Varredura rápida',
      discovery: 'Descoberta',
      enumeration: 'Enumeração',
      vulnerability: 'Vulnerabilidades',
      exploitation: 'Exploração',
      passive: 'Passivo',
      aggressive: 'Agressivo',
      credentials: 'Credenciais',
      recon: 'Reconhecimento',
      exploit: 'Exploração',
      bypass: 'Bypass',
      nmap: 'Varredura Nmap',
      nikto: 'Varredura Nikto',
      internal: 'Varredura interna',
      external: 'Varredura externa',
      network: 'Varredura de rede',
      owasp: 'Varredura OWASP',
      owasp_scan: 'Varredura OWASP',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'Varredura ZAP',
      zap_scan: 'Varredura ZAP',
      owasp_zap: 'Varredura OWASP ZAP',
      sqlmap: 'Varredura SQLMap',
      openvas: 'Varredura OpenVAS',
      nuclei: 'Varredura Nuclei',
      metasploit: 'Varredura Metasploit',
      hydra: 'Teste Hydra',
      wpscan: 'Varredura WordPress',
      gobuster: 'Varredura Gobuster',
      pentest: 'Pentest',
      stealth: 'Varredura furtiva',
      full_scan: 'Varredura completa',
      standard: 'Padrão'
    }
  },

  // Agents
  agents: {
    title: 'Agentes',
    subtitle: 'Agentes de varredura implantados em redes internas',
    loading: 'Carregando agentes...',
    register: 'Registrar',
    registerAgent: 'Registrar um agente',
    downloadInstaller: 'Baixar o instalador',
    searchPlaceholder: 'Pesquisar um agente...',
    noAgentsFound: 'Nenhum agente encontrado',
    noAgentsRegistered: 'Nenhum agente registrado',
    noAgentsFoundHint: 'Modifique sua pesquisa ou registre um novo agente',
    noAgentsRegisteredHint: 'Implante um agente em uma rede cliente para varrer alvos internos sem VPN',
    loadError: 'Erro ao carregar os agentes',
    deleteConfirm: 'Excluir o agente "{name}"?',
    colAgent: 'Agente',
    colStatus: 'Status',
    colHostname: 'Hostname',
    colInternalIp: 'IP Interno',
    colLastSeen: 'Última conexão',
    colMetrics: 'Métricas',
    colActions: 'Ações',
    never: 'Nunca',
    details: 'Detalhes',
    delete: 'Excluir',
    statTotal: 'Total',
    statOnline: 'Online',
    statOffline: 'Offline',
    statBusy: 'Ocupados',
    loadingAgent: 'A carregar o agente...',
    agentNotFound: 'Agente não encontrado',
    backToAgents: 'Voltar aos agentes',
    pingAgent: 'Ping',
    pinging: 'Ping...',
    systemCard: 'Sistema',
    networkCard: 'Rede',
    registeredCard: 'Registado',
    tunnelActive: 'Túnel ativo',
    polling: 'Polling',
    avg24h: 'méd. 24h',
    recentTasks: 'Tarefas recentes',
    noTasksExecuted: 'Nenhuma tarefa executada'
  },

  // Equipment types
  equipmentTypes: {
    deleteConfirm: 'Tem certeza de que deseja excluir este equipamento?',
    launchAttack: 'Lançar ataque',
    validateDetection: 'Validar detecção',
    deleteEquipment: 'Excluir',
    deleted: 'Equipamento excluído',
    validationError: 'Erro durante a validação',
    deleteError: 'Erro durante a exclusão',
    categories: {
      server: 'Servidor',
      workstation: 'Estação de trabalho',
      network: 'Rede',
      security: 'Segurança',
      iot: 'IoT',
      ot_ics: 'OT/ICS',
      mobile: 'Móvel',
      cloud: 'Cloud',
      container: 'Contêiner',
      database: 'Banco de dados',
      web_application: 'Aplicação Web',
      printer: 'Impressora',
      storage: 'Armazenamento',
      voip: 'VoIP',
      other: 'Outro'
    }
  },

  // Sessions extra
  sessionsExtra: {
    sessionNotFound: 'Sessão não encontrada',
    privescConfirm: 'Iniciar uma tentativa de escalada de privilégios?',
    validateForReport: 'Validar para relatório',
    chainNames: {
      full_recon: 'Reconhecimento Completo',
      cred_harvest: 'Coleta de Credenciais',
      pivot_recon: 'Descoberta de Pivot',
      safe_migrate: 'Migração Segura'
    },
    aptModules: 'Módulos APT (Ameaça Persistente Avançada)',
    modulesAvailable: 'módulos disponíveis'
  },

  // NetworkMap extra
  networkMap: {
    launchOwaspAnalysis: 'Serviços web - Iniciar análise OWASP',
    launchSimulation: 'Iniciar Simulação'
  },

  // ScanDetails extra
  scanDetails: {
    viewScanConfig: 'Ver configuração da varredura',
    downloadPdfReport: 'Baixar relatório PDF',
    pdfReport: 'Relatório PDF',
    relaunch: 'Reiniciar',
    relaunchScan: 'Reiniciar esta varredura com os mesmos parâmetros',
    schedule: 'Agendar',
    scheduleScan: 'Agendar esta varredura',
    refresh: 'Atualizar',
    vpnConnectionRequired: 'Conexão VPN necessária',
    vpnConnectionRequired2: 'Esta varredura requer uma conexão VPN para acessar a rede interna',
    vpnConnectInstructions: 'Conecte-se à VPN configurada para este espaço de trabalho e reinicie a varredura.',
    configureVpn: 'Configurar VPN',
    viewWorkspaces: 'Ver espaços de trabalho',
    vpnConnection: 'Conexão VPN',
    scanServer: 'Servidor de varredura',
    vpnActive: 'VPN Ativo',
    directConnection: 'Conexão direta',
    vpnServer: 'Servidor VPN',
    hostsDiscovered: 'Hosts descobertos',
    hostsDiscoveredDesc: 'Número total de máquinas descobertas e acessíveis no perímetro varrido.',
    totalVulnerabilities: 'Total de vulnerabilidades',
    totalVulnerabilitiesDesc: 'Número total de falhas de segurança (CVE) identificadas em todos os hosts.',
    criticalVulnerabilities: 'Vulnerabilidades críticas',
    criticalVulnerabilitiesDesc: 'CVSS 9.0-10.0: Falhas que permitem comprometimento total do sistema.',
    immediateActionRequired: 'Ação imediata necessária.',
    scanConfiguration: 'Configuração da varredura',
    target: 'Alvo',
    scanType: 'Tipo de varredura',
    createdAt: 'Criado em',
    intensity: 'Intensidade',
    queueHowItWorks: 'Como funciona a fila?',
    queueOrdered: 'As varreduras são processadas por ordem de chegada com prioridade conforme seu plano',
    queueAutoUpdate: 'Esta página é atualizada automaticamente',
    queueAutoStart: 'A varredura começará automaticamente quando houver recursos disponíveis',
    accelerateScans: 'Acelere suas varreduras',
    accelerateDesc: 'Para reduzir os tempos de espera e obter varreduras prioritárias:',
    proPlanOption: 'Plano Pro ou Enterprise',
    proPlanDesc: 'Aproveite maior prioridade na fila e tempos de espera reduzidos',
    dedicatedServer: 'Servidor dedicado',
    dedicatedServerDesc: 'Varreduras instantâneas sem fila - seus próprios recursos dedicados',
    viewPlans: 'Ver planos',
    noVulnDetected: 'Nenhuma vulnerabilidade detectada',
    showTop5: 'Mostrar as 5 mais graves',
    showAll: 'Mostrar tudo',
    viewAll: 'Ver tudo',
    viewDetails: 'Ver detalhes',
    showingTop5: 'Exibindo as 5 vulnerabilidades {sortType} de {total} no total',
    bySeverity: 'mais graves',
    byDate: 'mais recentes',
    capturedOn: 'Capturado em',
    imageLoadError: 'Erro ao carregar a imagem',
    autoGenerateReport: 'Gerar relatório automaticamente',
    selectReportFormats: 'Selecione o(s) formato(s) de relatório a gerar',
    reportFormats: 'Formatos de relatório',
    reduceList: '← Reduzir lista',
    showMoreHosts: 'Ver os outros {count} hosts →',
    stopScanConfirm: 'Tem certeza de que deseja parar esta varredura?',
    deleteScanConfirm: 'Tem certeza de que deseja excluir esta varredura?',
    retryScanConfirm: 'Reiniciar esta varredura com os mesmos parâmetros?',
    stopScanFailed: 'Erro ao parar a varredura',
    deleteScanFailed: 'Erro ao excluir a varredura',
    cleanupFailed: 'Erro de limpeza',
    immediatePatching: 'Correção imediata',
    immediatePatchingDesc: 'Aplicar patches de segurança para as vulnerabilidades críticas e altas identificadas.',
    reduceAttackSurface: 'Redução da superfície de ataque',
    reduceAttackSurfaceDesc: 'Fechar portas não essenciais e limitar a exposição dos serviços.',
    updateComponents: 'Atualização de componentes',
    updateComponentsDesc: 'Atualizar o software vulnerável para suas versões seguras mais recentes.',
    continuousMonitoring: 'Monitoramento contínuo',
    continuousMonitoringDesc: 'Implementar monitoramento de logs e alertas para detectar atividades suspeitas.',
    noCriticalVulnsDetected: 'Nenhuma vulnerabilidade crítica detectada',
    majorityLowSeverity: 'Maioria de vulnerabilidades de baixa gravidade',
    fullCoverageMultipleTools: 'Cobertura completa com múltiplas ferramentas de análise',
    automatedScanFastDetection: 'Varredura automatizada para detecção rápida',
    aiAssistedReport: 'Relatório gerado com assistência IA para análise aprofundada',
    implementSecurityRecommendations: 'Implementar recomendações de segurança',
    strengthenNetworkSegmentation: 'Reforçar a segmentação de rede',
    vulnManagementProgram: 'Programa de gestão de vulnerabilidades',
    regularSecurityAudits: 'Auditorias de segurança regulares',
    securityAwarenessTraining: 'Treinamento de conscientização de segurança',
    hostsLabel: 'Hosts',
    vulnerabilitiesLabel: 'Vulnerabilidades',
    criticalLabel: 'Críticos',
    highLabel: 'Altos',
    mediumLabel: 'Médios',
    lowLabel: 'Baixos',
    highVulnsDesc: 'CVSS 7.0-8.9: Falhas que podem levar a acesso não autorizado ou vazamento de dados.',
    mediumVulnsDesc: 'CVSS 4.0-6.9: Falhas que requerem condições específicas para serem exploradas.',
    lowVulnsDesc: 'CVSS 0.1-3.9: Falhas de impacto limitado, a tratar nas manutenções planejadas.'
  },

  // Subdomains
  subdomains: {
    title: 'Subdomain Discovery',
    description: 'Descubra subdomínios e lance ataques automatizados',
    searchTitle: 'Pesquisa de Subdomínios',
    domainPlaceholder: 'exemplo.com',
    scanning: 'Varrendo...',
    quickScan: 'Varredura rápida',
    fullScan: 'Varredura completa',
    toolsLabel: 'Ferramentas da varredura completa',
    sessionExpired: 'Sessão expirada. Por favor, faça login novamente.',
    discoveryError: 'Erro durante a descoberta de subdomínios',
    networkError: 'Erro de rede. Verifique sua conexão.',
    enterDomain: 'Por favor, insira um domínio',
    selectAtLeastOne: 'Selecione pelo menos um subdomínio',
    subdomainsDiscovered: '{count} subdomínios descobertos',
    savedToWorkspace: ' — salvo no espaço de trabalho',
    totalDiscovered: 'Total descobertos',
    active: 'Ativos (resolvíveis)',
    selected: 'Selecionados',
    duration: 'Duração',
    selectAllActive: 'Selecionar todos os ativos',
    deselectAll: 'Desmarcar tudo',
    scanSelected: 'Varrer seleção ({count})',
    attacking: 'Atacando...',
    scansLaunched: '{count} varredura(s) iniciada(s) nos subdomínios selecionados',
    discoveredSubdomains: 'Subdomínios descobertos',
    noAliveSubdomains: 'Nenhum subdomínio ativo encontrado',
    noAliveSubdomainsDesc: 'Este domínio pode não ter subdomínios publicamente indexados',
    resultsByTool: 'Resultados por ferramenta',
    emptyStateTitle: 'Subdomain Discovery',
    emptyStateDesc: 'Insira um domínio acima para descobrir todos os seus subdomínios.',
    quickScanHint: 'para uma pesquisa rápida com Subfinder,',
    fullScanHint: 'para uma pesquisa aprofundada.',
    configurableTools: 'Ferramentas configuráveis: Subfinder, Amass, DNSRecon, Resolução IP',
    dataFromWorkspace: 'Dados carregados do espaço de trabalho',
    rerunToRefresh: '— Reinicie uma varredura para atualizar',
    enrichedResultsSaved: 'Resultados enriquecidos salvos no espaço de trabalho',
    quickDiscoveryError: 'Erro durante a descoberta rápida'
  },

  // AI Agent
  aiAgent: {
    configTitle: 'Configuração do Agente',
    configSubtitle: 'Ajuste os limites e comportamentos do agente IA',
    reset: 'Redefinir',
    save: 'Salvar',
    generalSettings: 'Configurações gerais',
    agentActive: 'Agente ativo',
    automaticMonitoring: 'Monitoramento automático',
    autoRecovery: 'Auto-recuperação',
    automaticRecovery: 'Recuperação automática',
    dailyReport: 'Relatório diário',
    summaryEmail: 'E-mail de resumo',
    alertThresholds: 'Limites de alerta',
    alert: 'Alerta',
    critical: 'Crítico',
    memory: 'Memória',
    disk: 'Disco',
    intervals: 'Intervalos',
    monitoringSeconds: 'Monitoramento (segundos)',
    aiAnalysisSeconds: 'Análise IA (segundos)',
    healthCheckSeconds: 'Health Check (segundos)',
    scanSettings: 'Configurações de varredura',
    scanTimeoutMin: 'Timeout varredura (minutos)',
    maxConcurrentScans: 'Varreduras simultâneas máx.',
    errorRateThreshold: 'Taxa de erro limite (/h)',
    alerts: 'Alertas',
    alertEmail: 'E-mail de alerta',
    maxAlertsHour: 'Alertas máx./hora',
    deduplication: 'Deduplicação (minutos)',
    aiModels: 'Modelos IA',
    primaryModel: 'Modelo principal',
    strategicModel: 'Modelo estratégico',
    technicalModel: 'Modelo técnico',
    codeModel: 'Modelo de código',
    dailyReportSettings: 'Relatório diário',
    sendTime: 'Horário de envio',
    utcNote: '0-23 (hora UTC)',
    recipients: 'Destinatários (um por linha)',
    conversationHistory: 'Histórico de conversas IA',
    noConversations: 'Sem conversas',
    selectConversation: 'Selecione uma conversa',
    configSaved: 'Configuração salva',
    configSaveError: 'Erro ao salvar a configuração',
    configReset: 'Configuração redefinida',
    configResetError: 'Erro ao redefinir a configuração',
    configResetConfirm: 'Redefinir a configuração padrão?',
    deleteConversationConfirm: 'Excluir esta conversa?',
    conversationDeleted: 'Conversa excluída',
    conversationDeleteError: 'Erro ao excluir',
    loadMessagesError: 'Erro ao carregar as mensagens',
    untitledConversation: 'Conversa sem título',
    modelsTitle: 'Modelos IA (Ollama)',
    modelsSubtitle: 'Status dos modelos LLM usados pelo agente',
    ollamaOnline: 'Online',
    ollamaStopped: 'Parado',
    ollamaError: 'Erro',
    vramAvailable: 'Memória disponível para os modelos',
    defaultModel: 'Modelo padrão',
    availableModels: 'Modelos disponíveis',
    loaded: 'Carregado',
    available: 'Disponível',
    notAvailable: 'Indisponível',
    noModelsDetected: 'Nenhum modelo detectado',
    usageStats: 'Estatísticas de uso ({period})',
    totalRequests: 'Total de requisições',
    tokensUsed: 'Tokens utilizados',
    requestsByModel: 'Requisições por modelo',
    avgLatency: 'Latência média (ms)',
    testModel: 'Testar',
    modelError: 'Erro: {error}',
    testError: 'Erro durante o teste',
    loadModelsError: 'Erro ao carregar os modelos',
    actionsTitle: 'Histórico de Ações',
    actionsSubtitle: 'Ações executadas pelo agente IA',
    totalActions: 'Total de ações',
    successful: 'Bem-sucedidas',
    failed: 'Falhou',
    successRate: 'Taxa de sucesso',
    actionsByType: 'Ações por tipo',
    noActionsRecorded: 'Nenhuma ação registrada',
    filterType: 'Tipo',
    filterCategory: 'Categoria',
    filterResult: 'Resultado',
    all: 'Todos',
    allCategories: 'Todas',
    succeeded: 'Bem-sucedido',
    loadActionsError: 'Erro ao carregar as ações',
    metricsTitle: 'Métricas do sistema',
    noData: 'Sem dados',
    loadMetricsError: 'Erro ao carregar as métricas',
    incidentsTitle: 'Incidentes',
    incidentsSubtitle: 'Incidentes detectados pelo agente IA',
    acknowledge: 'Reconhecer',
    resolve: 'Resolver',
    retryRecovery: 'Reiniciar a recuperação',
    incidentAcknowledged: 'Incidente reconhecido',
    incidentResolved: 'Incidente resolvido',
    recoveryRelaunched: 'Recuperação reiniciada',
    loadIncidentsError: 'Erro ao carregar os incidentes',
    noIncidents: 'Sem incidentes',
    filterSeverity: 'Gravidade',
    filterStatus: 'Status',
    allSeverities: 'Todas',
    allStatuses: 'Todos'
  },

  // Orchestrator
  orchestrator: {
    title: 'Orquestrador IA',
    subtitle: 'Motor inteligente de exploração e análise autônoma',
    active: 'ATIVO',
    inactive: 'INATIVO',
    disable: 'Desativar',
    enable: 'Ativar (Modo Seguro)',
    enableSafe: 'Ativar',
    retry: 'Tentar novamente',
    connectionError: 'Erro de conexão com o orquestrador',
    serviceUnavailable: 'Serviço temporariamente indisponível. Por favor, tente novamente.',
    stateChangeError: 'Erro ao alterar o estado do orquestrador',
    activeScans: 'Varreduras ativas',
    aiDecisions: 'Decisões IA',
    aiModels: 'Modelos IA',
    minConfidence: 'Confiança mín.',
    loadedModels: 'Modelos IA carregados',
    loadingModels: 'Carregando modelos Ollama...',
    exploitationMode: 'Modo de exploração',
    confidenceThreshold: 'Limite de confiança',
    minConfidenceNote: 'Nível mínimo de confiança para ações automáticas',
    safeModeNote: 'O modo Seguro evita exploits destrutivos',
    recentDecisions: 'Decisões IA recentes',
    noAiActivity: 'Sem atividade IA',
    decisionsAppearHere: 'As análises e decisões IA aparecerão aqui',
    configuration: 'Configuração'
  },

  // License
  license: {
    expiredBadge: 'LICENÇA EXPIRADA',
    revokedBadge: 'LICENÇA REVOGADA',
    cancelledBadge: 'LICENÇA CANCELADA',
    noLicenseBadge: 'SEM LICENÇA',
    expiredTitle: 'Sua licença expirou',
    expiredSubtitle: 'O acesso à plataforma está suspenso aguardando renovação.',
    revokedTitle: 'Sua licença foi revogada',
    revokedSubtitle: 'O acesso à plataforma foi suspenso pela SYLink Security.',
    cancelledTitle: 'Sua licença foi cancelada',
    cancelledSubtitle: 'Sua assinatura foi cancelada. Seus dados são preservados por 30 dias.',
    noLicenseTitle: 'Sem licença ativa',
    noLicenseSubtitle: 'Ative uma licença para acessar a plataforma SYLink Pentest.',
    renewAction: 'Renovar minha licença',
    accessSettings: 'Acessar as configurações',
    contactSyLink: 'Contatar SYLink',
    subscribeAction: 'Assinar um novo plano',
    exportData: 'Exportar meus dados',
    activateLicense: 'Ativar minha licença',
    licenseInfo: 'Informações de licença',
    reference: 'Referência',
    tier: 'Nível',
    expiredOn: 'Expirado em',
    holder: 'Titular',
    expiry: 'Expiração',
    plan: 'Plano',
    loggedAs: 'Conectado como',
    adminBypass: 'Administrador - Redirecionando para o painel...',
    contactSupport: 'Contatar suporte',
    warningExpired: 'Seus dados estão preservados. Renove sua licença para restaurar o acesso completo.',
    warningExpiredEmail: 'Um e-mail de lembrete foi enviado para',
    warningRevoked: 'O acesso foi revogado por decisão administrativa.',
    warningCancelled: 'Sua assinatura foi cancelada. Você tem 30 dias para exportar seus dados.',
    warningNoLicense: 'Acesse as configurações da sua conta para inserir sua chave de licença.',
    needHelp: 'Precisa de ajuda?'
  },

  // Accept Invitation
  acceptInvitation: {
    verifying: 'Verificando o convite...',
    alreadyActivatedTitle: 'Conta já ativada',
    alreadyActivatedDesc: 'Sua conta foi ativada com sucesso. Você já pode fazer login.',
    login: 'Entrar',
    invitationExpiredTitle: 'Convite expirado',
    invitationInvalidTitle: 'Convite inválido',
    expiredHint: 'Os convites são válidos por 7 dias. Peça ao seu administrador que envie um novo.',
    invalidHint: 'Se você recebeu vários e-mails de convite, use o link do último.',
    contactSupport: 'Contatar suporte',
    welcomeTitle: 'Bem-vindo à equipe!',
    accountActivated: 'Sua conta foi ativada com sucesso.',
    redirecting: 'Redirecionando para o painel...',
    joinTeamTitle: 'Convite para entrar na equipe',
    missingToken: 'Token de convite ausente',
    acceptError: 'Erro ao aceitar o convite',
    genericError: 'Ocorreu um erro'
  },

  // Dedicated Server
  dedicatedServer: {
    pageTitle: 'Servidor dedicado - Infraestrutura soberana',
    heroTag: 'Solução soberana 100% portuguesa',
    heroTitle: 'Infraestrutura',
    heroTitleHighlight: 'Dedicada',
    heroDesc: 'Uma solução de pentest isolada, gerida e supervisionada para a sua empresa. Alojada em Portugal, sem as restrições das soluções estrangeiras.',
    statFrench: 'Portuguesa',
    statQueue: 'Fila de espera',
    statSupervision: 'Supervisão',
    statAvailability: 'Disponibilidade',
    whyDedicated: 'Porquê escolher a infraestrutura dedicada?',
    whyDedicatedDesc: 'Beneficie de uma solução personalizada adaptada às suas exigências de segurança e desempenho',
    hostingOptions: 'Opções de alojamento',
    hostingOptionsDesc: 'Escolha o alojamento que corresponde às suas necessidades: no nosso datacenter soberano ou diretamente na sua infraestrutura',
    recommended: 'Recomendado',
    aiTitle: 'SYLink IA - Modelos especializados em cibersegurança',
    aiDesc: 'Implemente a nossa IA especializada em cibersegurança diretamente na sua infraestrutura. Análise local, sem envio de dados para o exterior.',
    parameters: 'parâmetros',
    poweredBy: 'Desenvolvido por Ollama',
    localLLM: 'Execução local de modelos LLM',
    viewOnOllama: 'Ver no Ollama',
    ctaTitle: 'Pronto para avançar para a infraestrutura dedicada?',
    ctaDesc: 'Contacte a nossa equipa comercial para uma avaliação personalizada das suas necessidades e um orçamento à medida.',
    requestQuote: 'Solicitar orçamento',
    viewAllPlans: 'Ver todos os planos',
    trustFrenchTech: 'Tecnologia europeia',
    trustFrenchTechDesc: 'Desenvolvido na Europa, sem dependência de tecnologias estrangeiras',
    trustGDPR: 'Conformidade RGPD',
    trustGDPRDesc: 'Alojamento soberano conforme com os regulamentos europeus',
    trustProtectedData: 'Dados protegidos',
    trustProtectedDataDesc: 'Os seus dados permanecem protegidos do Cloud Act e do FISA',
    adv1Title: 'Isolamento Total',
    adv1Desc: 'Infraestrutura dedicada e isolada para máxima segurança. Sem partilha de recursos com outros clientes.',
    adv2Title: 'Desempenho Garantido',
    adv2Desc: 'Recursos CPU, RAM e armazenamento dedicados. Análises instantâneas sem filas de espera nem limitações.',
    adv3Title: 'Soberania dos dados',
    adv3Desc: 'Alojamento 100% europeu, sem as restrições das soluções estrangeiras (Cloud Act, FISA).',
    adv4Title: 'Supervisão 24/7',
    adv4Desc: 'Monitorização contínua, alertas em tempo real e intervenção proativa das nossas equipas.',
    adv5Title: 'Suporte Dedicado',
    adv5Desc: 'Equipa técnica dedicada, SLA garantido e acompanhamento personalizado.',
    adv6Title: 'Disponibilidade 99,9%',
    adv6Desc: 'Infraestrutura redundante com alta disponibilidade e plano de recuperação de atividade.',
    hostingDatacenterTitle: 'Data Center Europeu',
    hostingDatacenterLoc: 'Europa',
    hostingOnPremTitle: 'On-premise',
    hostingOnPremLoc: 'A sua infraestrutura',
    ai8bDesc: 'Modelo leve e rápido para análises padrão',
    ai8bSpecs: 'GPU: mínimo 8 GB VRAM',
    ai8bUseCase: 'Análises rápidas, relatórios automatizados',
    ai30bDesc: 'Modelo equilibrado para análises aprofundadas',
    ai30bSpecs: 'GPU: mínimo 24 GB VRAM',
    ai30bUseCase: 'Análises detalhadas, correlações avançadas',
    ai80bDesc: 'Modelo especialista para análises complexas',
    ai80bSpecs: 'GPU: mínimo 80 GB VRAM',
    ai80bUseCase: 'Análises especializadas, pesquisa de vulnerabilidades'
  },

  // Account Reports Config page
  accountReports: {
    configSaved: 'Configuração guardada',
    configSaveError: 'Erro ao guardar a configuração',
    clientAdded: 'Cliente adicionado',
    clientAddError: 'Erro ao adicionar',
    clientDeleted: 'Cliente eliminado',
    clientDeleteError: 'Erro ao eliminar',
    loadError: 'Erro ao carregar',
    deleteClientConfirm: 'Eliminar este cliente?',
    unsavedChanges: 'Tem alterações não guardadas',
    save: 'Guardar',
    saving: 'A guardar...',
    clientsTitle: 'Clientes',
    addClient: 'Adicionar',
    clientName: 'Nome do cliente *',
    sirenOptional: 'SIREN (opcional)',
    noClientsConfigured: 'Nenhum cliente configurado',
    reportTypesTitle: 'Tipos de Relatórios',
    reportTypesDesc: 'Personalize os tipos de relatórios disponíveis para a sua organização',
    customName: 'Nome personalizado',
    customDescription: 'Descrição personalizada',
    infoNote: 'Estas definições são específicas da sua organização. As alterações afetam apenas os seus relatórios.'
  }
};
